/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface GetSentEmailsResponse {
  data: {
    /** @format uuid */
    id: string;
    createdAt: string;
    recipient: string;
    subject: string;
    status: "sent" | "failed";
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetSentEmailResponse {
  data: {
    /** @format uuid */
    id: string;
    createdAt: string;
    recipient: string;
    cc: string | null;
    sender: string;
    subject: string;
    html: string | null;
    text: string | null;
    status: "sent" | "failed";
    error: string | null;
  };
}

export interface FileUploadResponse {
  fileKey: string;
  fileUrl: string;
}

export interface GetUsersResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    phoneNumber: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    subscriptions?: {
      id: string;
      studentId: string;
      subjectTitle: string;
      schoolClass: string;
      /** @format uuid */
      schoolClassId: string;
      endDate: string | null;
      classId: string;
    }[];
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetAllUsersResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    phoneNumber: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    subscriptions?: {
      id: string;
      studentId: string;
      subjectTitle: string;
      schoolClass: string;
      /** @format uuid */
      schoolClassId: string;
      endDate: string | null;
      classId: string;
    }[];
  }[];
}

export interface GetStaffUsersResponse {
  data: {
    /** @format uuid */
    id: string;
    firstName: string;
    lastName: string;
  }[];
}

export interface GetUserByIdResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    phoneNumber: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  } & {
    marketingConsent: boolean;
  };
}

export interface GetUserAvatarsResponse {
  data: {
    /** @format uuid */
    id: string;
    avatarS3Url: string;
  }[];
}

export interface UpdateUserAvatarResponse {
  data: {
    message: string;
  };
}

export interface GetUserDetailsResponse {
  data: {
    firstName: string | null;
    lastName: string | null;
    /** @format uuid */
    id: string;
    description: string | null;
    contactEmail: string | null;
    contactPhone: string | null;
    jobTitle: string | null;
    userAvatarId: string;
    guardian: {
      /** @format uuid */
      guardianId: string;
      guardianFirstName: string;
      guardianLastName: string;
      guardianEmail: string;
    } | null;
  };
}

export type GetStudentsCsvResponse = string;

export interface UpdateUserBody {
  firstName?: string;
  lastName?: string;
  /** @format email */
  email?: string;
  role?: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
  archived?: boolean;
}

export interface UpdateUserResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    phoneNumber: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  };
}

export interface UpdateMyDataBody {
  firstName?: string;
  lastName?: string;
  /** @format email */
  email?: string;
  phoneNumber?: string | null;
  marketingConsent?: boolean;
  marketingEmailConsent?: boolean;
}

export interface UpdateMyDataResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    phoneNumber: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  };
}

export interface UpsertStudentDetailsBody {
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  marketingConsent?: boolean;
}

export interface UpsertStudentDetailsResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpsertUserDetailsBody {
  description?: string;
  /** @format email */
  contactEmail?: string;
  contactPhoneNumber?: string;
  jobTitle?: string;
}

export interface UpsertUserDetailsResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface AdminUpdateUserBody {
  firstName?: string;
  lastName?: string;
  role?: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
  hasFreeAccess?: boolean;
  bannedAt?: string | null;
  bannedReason?: string | null;
  isActive?: boolean;
  marketingConsent?: boolean;
}

export interface AdminUpdateUserResponse {
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    hasFreeAccess: boolean;
    authenticationType: string;
    bannedAt: string | null;
    archivedAt: string | null;
    bannedReason: string | null;
    username: string | null;
    phoneNumber: string | null;
    marketingConsent: boolean;
    emailVerified: boolean;
    image: string | null;
    role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
    isActive?: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  } & {
    marketingConsent: boolean;
  };
}

export interface BanUserBody {
  userId: string;
  bannedAt: string | null;
  bannedReason: string | null;
}

export interface BanUserResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface ChangePasswordBody {
  /**
   * @minLength 8
   * @maxLength 64
   */
  newPassword: string;
  /**
   * @minLength 8
   * @maxLength 64
   */
  oldPassword: string;
}

export type ChangePasswordResponse = null;

export interface ArchiveUserResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export type DeleteUserResponse = null;

export interface DeleteBulkUsersBody {
  userIds: string[];
}

export type DeleteBulkUsersResponse = null;

export interface CreateUserBody {
  /** @format email */
  email: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  lastName: string;
  role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
  hasFreeAccess?: boolean;
}

export interface CreateUserResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface DeviceInfo {
  /** @format uuid */
  deviceId: string;
  deviceType: string;
  deviceVendor?: string | null;
  deviceModel?: string | null;
  deviceOs: string;
  deviceOsVersion: string;
  deviceBrowser: string;
  deviceBrowserVersion: string;
}

export interface SendVerificationEmailResponse {
  data: void;
}

export interface VerifyDeviceResponse {
  data: boolean;
}

export interface SendToUserBody {
  event:
    | "notification"
    | "system_notification"
    | "payment_status_success"
    | "request_subscription_status"
    | "video_progress_update"
    | "new_system_message"
    | "achievement_awarded"
    | "device_verified";
  message: string;
  type?: "info" | "warning" | "error" | "success";
}

export interface SendToUserResponse {
  data: {
    success: boolean;
    message: string;
  };
}

export interface SendToRoleBody {
  event:
    | "notification"
    | "system_notification"
    | "payment_status_success"
    | "request_subscription_status"
    | "video_progress_update"
    | "new_system_message"
    | "achievement_awarded"
    | "device_verified";
  message: string;
  type?: "info" | "warning" | "error" | "success";
}

export interface SendToRoleResponse {
  data: {
    success: boolean;
    message: string;
  };
}

export interface SendToAllBody {
  event:
    | "notification"
    | "system_notification"
    | "payment_status_success"
    | "request_subscription_status"
    | "video_progress_update"
    | "new_system_message"
    | "achievement_awarded"
    | "device_verified";
  message: string;
  type?: "info" | "warning" | "error" | "success";
}

export interface SendToAllResponse {
  data: {
    success: boolean;
    message: string;
  };
}

export interface MarkLessonAsCompletedResponse {
  data: {
    /** @format uuid */
    lessonId: string;
    message: string;
  };
}

export interface GetVideoProgressResponse {
  data: {
    currentPosition: number;
    watchedDuration: number;
    lastUpdatedAt?: string;
  };
}

export interface GetVideoStatisticsResponse {
  data: {
    viewerCount: number;
  };
}

export interface GetUserStatisticsResponse {
  data: {
    averageStats: {
      lessonStats: {
        started: number;
        completed: number;
        completionRate: number;
      };
      courseStats: {
        started: number;
        completed: number;
        completionRate: number;
      };
    };
    quizzes: {
      totalAttempts: number;
      totalCorrectAnswers: number;
      totalWrongAnswers: number;
      totalQuestions: number;
      averageScore: number;
      uniqueQuizzesTaken: number;
    };
    courses: object;
    lessons: object;
    streak: {
      current: number;
      longest: number;
      activityHistory: object;
    };
    nextLesson: {
      /** @format uuid */
      courseId: string;
      courseTitle: string;
      courseDescription: string;
      courseThumbnail: string;
      /** @format uuid */
      lessonId: string;
      chapterTitle: string;
      chapterProgress: "not_started" | "in_progress" | "completed";
      completedLessonCount: number;
      lessonCount: number;
      chapterDisplayOrder: number;
    } | null;
  };
}

export interface GetUserLessonCompletionStatsResponse {
  data: {
    totalLessons: number;
    completedLessons: number;
    averageQuizScore: number;
    averageTestScore: number;
  };
}

export interface GetUserWeeklyStatsResponse {
  data: {
    quizzes: {
      weekStartDate: string;
      weekEndDate: string;
      /** @format uuid */
      subjectId: string;
      /** @format uuid */
      schoolClassId: string;
      completedQuizzesCount: number;
    }[];
    exams: {
      weekStartDate: string;
      weekEndDate: string;
      /** @format uuid */
      subjectId: string;
      /** @format uuid */
      schoolClassId: string;
      completedExamsCount: number;
    }[];
  };
}

export interface InitPurchaseBody {
  /** @format email */
  buyerEmail: string;
  /** @format email */
  studentEmail: string;
  /**
   * @maxItems 3
   * @minItems 1
   */
  subjectIds: string[];
  /** @format uuid */
  schoolClassId: string;
  returnUrl: string;
  discountCode?: string;
  marketingEmailConsent?: boolean;
}

export interface RegisterTransactionBody {
  /** @format uuid */
  tutorSubjectId: string;
  startsAt: string;
  /** @format uri */
  returnUrl: string;
  /** @format uuid */
  studentId?: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  topic: string;
  marketingEmailConsent?: boolean;
}

export interface RegisterBlikRecurringBody {
  /** @pattern ^[0-9]{6}$ */
  blikCode: string;
  /** @format uri */
  returnUrl: string;
  /** @format email */
  guardianEmail: string;
  /** @format email */
  studentEmail: string;
  /** @min 0 */
  amount?: number;
  interval?: "weekly" | "monthly";
  /** @format uuid */
  subscriptionPlanId?: string;
  /** @format uuid */
  subscriptionClassId: string;
  /** @minItems 1 */
  subscriptionSubjectIds: string[];
  discountCode?: string;
  marketingEmailConsent?: boolean;
}

export interface ReauthorizeBlikBody {
  /** @format uuid */
  subscriptionId: string;
  /** @pattern ^[0-9]{6}$ */
  blikCode: string;
  /** @format uri */
  returnUrl: string;
}

export interface ExecutePaymentBody {
  token: string;
}

export interface RegisterGuardianBody {
  guardianToken: string;
}

export interface RegisterStudentBody {
  studentToken: string;
}

export interface GetTransactionStatusResponse {
  transaction: {
    status: string;
    amount: number;
    sessionId: string;
    userId: string | null;
    studentEmail: string | null;
    subscriptionClassId: string;
    subscriptionSubjectIds: string[];
    subscriptionPlanId: string | null;
    schoolClassName: string | null;
    hasOtherSubscriptions: boolean;
    paymentMethod: {
      cardMask: string | null;
      cardType: string | null;
      category: "fast";
    } | null;
  } | null;
  purchaseToken: {
    guardianRegistered: boolean;
    studentRegistered: boolean;
    completed: boolean;
  } | null;
}

export interface GetUpsellPreviewResponse {
  /** @format uuid */
  subscriptionId: string;
  schoolClassName: string;
  currentSubjects: string[];
  addedSubjects: string[];
  oldAmount: number;
  newAmount: number;
  chargeAmount: number;
  remainingDays: number;
  periodDays: number;
  renewalDate: string;
  currency: string;
}

export interface InitUpsellBody {
  /** @format email */
  studentEmail: string;
  /** @format uuid */
  schoolClassId: string;
  /** @minItems 1 */
  subjectIds: string[];
  /** @format uri */
  returnUrl: string;
  /** @format email */
  initiatorEmail?: string;
  interval?: string;
  /** @pattern ^[0-9]{6}$ */
  blikCode?: string;
  marketingEmailConsent?: boolean;
}

export interface InitUpsellResponse {
  applied: boolean;
  sessionId: string | null;
  redirectUrl: string | null;
}

export type GetSubscriptionPricingResponse = {
  interval: string;
  subjectCount: number;
  price: number;
  oldPrice: number | null;
}[];

export interface QuoteSubscriptionBody {
  /** @format uuid */
  subscriptionClassId: string;
  /** @minItems 1 */
  subscriptionSubjectIds: string[];
  interval?: "weekly" | "monthly";
  /** @format uuid */
  subscriptionPlanId?: string;
  discountCode?: string;
}

export interface QuoteSubscriptionResponse {
  basePrice: number;
  amount: number;
  discountPercentage: number;
}

export interface GetStudentSubjectsResponse {
  studentExists: boolean;
  assignedSubjects: {
    subjectTitle: string;
    endDate: string | null;
    interval: string;
  }[];
}

export type GetSavedCardsResponse = {
  refId: string | null;
  cardMask: string | null;
  cardType: string | null;
}[];

export interface GetDiscountCodesResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    code: string;
    /** @maxLength 200 */
    name: string;
    discountPercentage: number;
    expirationDate: string | null;
    codeUsage: (string | number | boolean | null) | any[] | object;
    userId: string;
    codeType: string;
    schoolClassIds: string[];
    usageCount: number;
    maxUsageCount: number | null;
    isActive: boolean;
    prefix: string | null;
    generatedCount: number | null;
    validUntil: string | null;
    renewalCycles: number | null;
    regulationUrl: string | null;
    usedAt: string | null;
    usedByEmail: string | null;
    usedInClassId: string | null;
    usedInClassName: string | null;
  }[];
}

export interface CreateDiscountCodeBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  /** @maxLength 200 */
  name: string;
  discountPercentage: number;
  expirationDate?: string | null;
  userId: string;
  codeType?: string;
  schoolClassIds: string[];
  usageCount?: number;
  maxUsageCount?: number | null;
  isActive?: boolean;
  prefix?: string | null;
  generatedCount?: number | null;
  validUntil?: string | null;
  renewalCycles?: number | null;
  regulationUrl?: string | null;
}

export interface CreateDiscountCodeResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    code: string;
    /** @maxLength 200 */
    name: string;
    discountPercentage: number;
    expirationDate: string | null;
    codeUsage: (string | number | boolean | null) | any[] | object;
    userId: string;
    codeType: string;
    schoolClassIds: string[];
    usageCount: number;
    maxUsageCount: number | null;
    isActive: boolean;
    prefix: string | null;
    generatedCount: number | null;
    validUntil: string | null;
    renewalCycles: number | null;
    regulationUrl: string | null;
  };
}

export interface GetAllDiscountCodesResponse {
  data: (
    | {
        id: string;
        createdAt: string;
        updatedAt: string;
        code: string;
        /** @maxLength 200 */
        name: string;
        discountPercentage: number;
        expirationDate: string | null;
        userId: string;
        schoolClassIds: string[];
        usageCount: number;
        maxUsageCount: number | null;
        isActive: boolean;
        prefix: string | null;
        generatedCount: number | null;
        validUntil: string | null;
        renewalCycles: number | null;
        regulationUrl: string | null;
        usedAt: string | null;
        usedByEmail: string | null;
        usedInClassId: string | null;
        usedInClassName: string | null;
        codeType: "SINGLE_USE" | "MULTI_USE";
        schoolClassNames: string[];
        status: "ACTIVE" | "INACTIVE" | "EXPIRED" | "USED";
        usageInfo: string;
        type: "individual";
        codes: null;
      }
    | {
        id: string;
        createdAt: string;
        updatedAt: string;
        code: string;
        /** @maxLength 200 */
        name: string;
        discountPercentage: number;
        expirationDate: string | null;
        userId: string;
        schoolClassIds: string[];
        usageCount: number;
        maxUsageCount: number | null;
        isActive: boolean;
        prefix: string | null;
        generatedCount: number | null;
        validUntil: string | null;
        renewalCycles: number | null;
        regulationUrl: string | null;
        usedAt: string | null;
        usedByEmail: string | null;
        usedInClassId: string | null;
        usedInClassName: string | null;
        codeType: "SINGLE_USE" | "MULTI_USE";
        schoolClassNames: string[];
        status: "ACTIVE" | "INACTIVE" | "EXPIRED" | "USED";
        usageInfo: string;
        type: "batch";
        codes: {
          id: string;
          createdAt: string;
          updatedAt: string;
          code: string;
          /** @maxLength 200 */
          name: string;
          discountPercentage: number;
          expirationDate: string | null;
          userId: string;
          schoolClassIds: string[];
          usageCount: number;
          maxUsageCount: number | null;
          isActive: boolean;
          prefix: string | null;
          generatedCount: number | null;
          validUntil: string | null;
          renewalCycles: number | null;
          regulationUrl: string | null;
          usedAt: string | null;
          usedByEmail: string | null;
          usedInClassId: string | null;
          usedInClassName: string | null;
          codeType: "SINGLE_USE" | "MULTI_USE";
          schoolClassNames: string[];
          status: "ACTIVE" | "INACTIVE" | "EXPIRED" | "USED";
          usageInfo: string;
        }[];
      }
  )[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetDiscountCodeDetailsResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    code: string;
    /** @maxLength 200 */
    name: string;
    discountPercentage: number;
    expirationDate: string | null;
    userId: string;
    schoolClassIds: string[];
    usageCount: number;
    maxUsageCount: number | null;
    isActive: boolean;
    prefix: string | null;
    generatedCount: number | null;
    validUntil: string | null;
    renewalCycles: number | null;
    regulationUrl: string | null;
    usedAt: string | null;
    usedByEmail: string | null;
    usedInClassId: string | null;
    usedInClassName: string | null;
    codeType: "SINGLE_USE" | "MULTI_USE";
    schoolClassNames: string[];
    status: "ACTIVE" | "INACTIVE" | "EXPIRED" | "USED";
    usageInfo: string;
  };
}

export interface CreateAdminDiscountCodesBody {
  /** @maxLength 200 */
  name?: string;
  codeType: "SINGLE_USE" | "MULTI_USE";
  /**
   * @min 1
   * @max 100
   */
  discountPercentage: number;
  /** @format date-time */
  expirationDate: string;
  /** @minItems 1 */
  schoolClassIds: string[];
  /** @min 1 */
  generatedCount?: number;
  /** @maxLength 100 */
  prefix?: string;
  /** @min 1 */
  maxUsageCount?: number;
  /** @format date-time */
  validUntil?: string;
  /** @min 1 */
  renewalCycles?: number;
  regulationUrl?: string;
}

export interface CreateAdminDiscountCodesResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    code: string;
    /** @maxLength 200 */
    name: string;
    discountPercentage: number;
    expirationDate: string | null;
    userId: string;
    schoolClassIds: string[];
    usageCount: number;
    maxUsageCount: number | null;
    isActive: boolean;
    prefix: string | null;
    generatedCount: number | null;
    validUntil: string | null;
    renewalCycles: number | null;
    regulationUrl: string | null;
    usedAt: string | null;
    usedByEmail: string | null;
    usedInClassId: string | null;
    usedInClassName: string | null;
    codeType: "SINGLE_USE" | "MULTI_USE";
    schoolClassNames: string[];
    status: "ACTIVE" | "INACTIVE" | "EXPIRED" | "USED";
    usageInfo: string;
  }[];
}

export interface ArchiveDiscountCodeBody {
  isActive: boolean;
}

export interface ArchiveDiscountCodeResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    code: string;
    /** @maxLength 200 */
    name: string;
    discountPercentage: number;
    expirationDate: string | null;
    userId: string;
    schoolClassIds: string[];
    usageCount: number;
    maxUsageCount: number | null;
    isActive: boolean;
    prefix: string | null;
    generatedCount: number | null;
    validUntil: string | null;
    renewalCycles: number | null;
    regulationUrl: string | null;
    usedAt: string | null;
    usedByEmail: string | null;
    usedInClassId: string | null;
    usedInClassName: string | null;
    codeType: "SINGLE_USE" | "MULTI_USE";
    schoolClassNames: string[];
    status: "ACTIVE" | "INACTIVE" | "EXPIRED" | "USED";
    usageInfo: string;
  };
}

export interface GetDiscountCodeUsageHistoryResponse {
  data: {
    /** @format uuid */
    id: string;
    code: string;
    usedAt: string | null;
    usedByEmail: string | null;
    usedInClassId: string | null;
    usedInClassName: string | null;
    schoolClassNames: string[];
    discountCyclesUsed: number | null;
    remainingCycles: number | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetUserDiscountCodesUsageResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    code: string;
    codeType: string;
    discountPercentage: number;
    usedAt: string | null;
    usedInClassId: string | null;
    usedInClassName: string | null;
    schoolClassIds: string[] | null;
    schoolClassNames: string[];
  }[];
}

export interface ApplyDiscountCodeBody {
  codeValue: string;
  /** @format email */
  userEmail: string;
  schoolClassIds: string[];
}

export interface ApplyDiscountCodeResponse {
  data: {
    success: boolean;
    message: string;
    data?: {
      id: string;
      createdAt: string;
      updatedAt: string;
      code: string;
      /** @maxLength 200 */
      name: string;
      discountPercentage: number;
      expirationDate: string | null;
      codeUsage: (string | number | boolean | null) | any[] | object;
      userId: string;
      codeType: string;
      schoolClassIds: string[];
      usageCount: number;
      maxUsageCount: number | null;
      isActive: boolean;
      prefix: string | null;
      generatedCount: number | null;
      validUntil: string | null;
      renewalCycles: number | null;
      regulationUrl: string | null;
    };
  };
}

export interface TrackBody {
  /** @format email */
  guardianEmail: string;
  /** @format uuid */
  schoolClassId: string;
}

export type TrackResponse = null;

export interface GetGuardianStudentsResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
  }[];
}

export interface AddGuardianBody {
  /** @format email */
  email: string;
}

export interface AddGuardianResponse {
  data: {
    message: string;
    newGuardian: boolean;
  };
}

export interface LinkStudentBody {
  token: string;
}

export interface LinkStudentResponse {
  data:
    | {
        /** @format uuid */
        id: string;
        /** @format date-time */
        createdAt: string;
        /** @format date-time */
        updatedAt: string;
        /** @format uuid */
        guardianId: string;
        /** @format uuid */
        studentId: string;
      }
    | {
        /** @format uuid */
        id: string;
        /** @format date-time */
        createdAt: string;
        /** @format date-time */
        updatedAt: string;
        /** @format uuid */
        guardianId: string;
        /** @format uuid */
        studentId: string;
      }[];
}

export interface ValidateStudentGuardianRelationshipBody {
  /** @format email */
  studentEmail: string;
  /** @format email */
  guardianEmail: string;
}

export interface ValidateStudentGuardianRelationshipResponse {
  data: {
    isValid: boolean;
    message?: string;
  };
}

export interface GetAllSubjectsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    archived: boolean | null;
    createdAt: string | null;
    code: "MATH" | "POLISH" | "ENGLISH" | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetSubjectByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    archived: boolean | null;
    createdAt: string | null;
    code: "MATH" | "POLISH" | "ENGLISH" | null;
  };
}

export interface GetSubjectsByIdsBody {
  ids: string[];
}

export interface GetSubjectsByIdsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    archived: boolean | null;
    createdAt: string | null;
    code: "MATH" | "POLISH" | "ENGLISH" | null;
  }[];
}

export interface CreateSubjectBody {
  title: string;
}

export interface CreateSubjectResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateSubjectBody {
  /** @format uuid */
  id?: string;
  title?: string;
  archived?: boolean;
}

export interface UpdateSubjectResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    archived: boolean | null;
    createdAt: string | null;
    code: "MATH" | "POLISH" | "ENGLISH" | null;
  };
}

export interface GetAllCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    thumbnailUrl: string | null;
    thumbnailAlt?: string;
    description: string;
    /** @format uuid */
    authorId?: string;
    author: string;
    authorEmail?: string;
    subject: string;
    chapters?: {
      /** @format uuid */
      id: string;
      title: string;
      lessons?: {
        /** @format uuid */
        id: string;
        title: string;
        type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
        description?: string | null;
        status?: string;
        displayOrder: number;
        fileUrl?: string | null;
        questions?: {
          /** @format uuid */
          id?: string;
          type:
            | "scale_1_5"
            | "single_choice"
            | "free_choice"
            | "multiple_choice"
            | "true_or_false"
            | "fill_in_the_blanks_text"
            | "fill_in_the_blanks_dnd"
            | "sorting"
            | "ai_graded_open_answer";
          description?: string | null;
          title: string;
          displayOrder?: number;
          solutionExplanation?: string | null;
          solutionKey?: string | null;
          photoS3Key?: string | null;
          photoAlt?: string | null;
          media?: {
            /** @format uuid */
            id?: string;
            type: "audio" | "text";
            s3Key?: string | null;
            content?: string | null;
            name?: string | null;
            displayOrder: number | null;
          }[];
          options?: {
            /** @format uuid */
            id?: string;
            optionText: string;
            displayOrder: number | null;
            isStudentAnswer?: boolean | null;
            isCorrect: boolean;
            /** @format uuid */
            questionId?: string;
            scaleAnswer?: number | null;
          }[];
        }[];
        /** @format date-time */
        updatedAt?: string;
        highlights?: {
          /** @format uuid */
          id?: string;
          title: string;
          photoS3Key?: string;
          photoS3Url?: string;
          timestamp: number;
          photoAlt?: string | null;
        }[];
        additionalResources?: {
          /** @format uuid */
          id?: string;
          title: string;
          fileS3Key: string;
          fileS3Url?: string;
          fileName: string;
          fileNameToDownload: string | null;
          fileExtension?: string;
          fileSize?: number | null;
          /** @format date-time */
          createdAt?: string;
        }[];
        isFreemium?: boolean;
        parentLessonId?: string | null;
      }[];
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      displayOrder: number;
      schoolClass?: string;
    }[];
    courseLessonCount: number;
    isPublished?: boolean;
    /** @format date-time */
    createdAt?: string;
    hasFreeLesson?: boolean;
    teacherId: string;
    subjectId?: string;
    schoolClassId: string;
    isCkeExam: boolean;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetStudentCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    thumbnailUrl: string | null;
    thumbnailAlt?: string;
    description: string;
    /** @format uuid */
    authorId?: string;
    author: string;
    authorEmail?: string;
    subject: string;
    chapters?: {
      /** @format uuid */
      id: string;
      title: string;
      lessons?: {
        /** @format uuid */
        id: string;
        title: string;
        type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
        description?: string | null;
        status?: string;
        displayOrder: number;
        fileUrl?: string | null;
        questions?: {
          /** @format uuid */
          id?: string;
          type:
            | "scale_1_5"
            | "single_choice"
            | "free_choice"
            | "multiple_choice"
            | "true_or_false"
            | "fill_in_the_blanks_text"
            | "fill_in_the_blanks_dnd"
            | "sorting"
            | "ai_graded_open_answer";
          description?: string | null;
          title: string;
          displayOrder?: number;
          solutionExplanation?: string | null;
          solutionKey?: string | null;
          photoS3Key?: string | null;
          photoAlt?: string | null;
          media?: {
            /** @format uuid */
            id?: string;
            type: "audio" | "text";
            s3Key?: string | null;
            content?: string | null;
            name?: string | null;
            displayOrder: number | null;
          }[];
          options?: {
            /** @format uuid */
            id?: string;
            optionText: string;
            displayOrder: number | null;
            isStudentAnswer?: boolean | null;
            isCorrect: boolean;
            /** @format uuid */
            questionId?: string;
            scaleAnswer?: number | null;
          }[];
        }[];
        /** @format date-time */
        updatedAt?: string;
        highlights?: {
          /** @format uuid */
          id?: string;
          title: string;
          photoS3Key?: string;
          photoS3Url?: string;
          timestamp: number;
          photoAlt?: string | null;
        }[];
        additionalResources?: {
          /** @format uuid */
          id?: string;
          title: string;
          fileS3Key: string;
          fileS3Url?: string;
          fileName: string;
          fileNameToDownload: string | null;
          fileExtension?: string;
          fileSize?: number | null;
          /** @format date-time */
          createdAt?: string;
        }[];
        isFreemium?: boolean;
        parentLessonId?: string | null;
      }[];
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      displayOrder: number;
      schoolClass?: string;
    }[];
    courseLessonCount: number;
    isPublished?: boolean;
    /** @format date-time */
    createdAt?: string;
    hasFreeLesson?: boolean;
    teacherId: string;
    subjectId?: string;
    schoolClassId: string;
    isCkeExam: boolean;
    completedLessonCount: number;
    quizCount: number;
    courseStatus: "not_started" | "in_progress" | "completed";
    isEnrolled: boolean;
    schoolClass?: string;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetSubjectCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    lessons: {
      /** @format uuid */
      id: string;
      type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
      title: string;
      questionsCount: number | null;
      isFreemium: boolean;
      status: "not_started" | "in_progress" | "completed";
    }[];
    isEnrolled: boolean;
    hasFreeLesson: boolean;
  }[];
}

export interface GetStudentClassSelectionResponse {
  data: {
    id?: string | null;
    /** @format uuid */
    subjectId: string;
    /** @format uuid */
    schoolClassId: string;
    subjectName: string;
    schoolClassName: string;
    teacherId?: string | null;
    isEnrolled?: boolean;
    hasStartedLessonForSubscription: boolean;
    hasFreeLesson: boolean;
    courseCount: number;
    completedCourseCount: number;
    lessonCount: number;
    lessonCountWithQuiz: number;
    completedLessonCountWithQuiz: number;
    inProgressCourseCount: number;
    additionalResourceCount: number;
    subscriptionStatus?:
      | (
          | "pending"
          | "active"
          | "cancelled"
          | "expired"
          | "suspended"
          | "payment_failed"
          | "payment_coming_soon"
          | "merged"
        )
      | null;
    subscriptionId?: string | null;
    subjectDescription: string | null;
    subjectImageS3Key: string | null;
    subjectImageAlt: string | null;
  }[];
}

export interface GetTrialStudentClassSelectionResponse {
  data: {
    id?: string | null;
    /** @format uuid */
    subjectId: string;
    /** @format uuid */
    schoolClassId: string;
    subjectName: string;
    schoolClassName: string;
    teacherId?: string | null;
    isEnrolled?: boolean;
    hasStartedLessonForSubscription: boolean;
    hasFreeLesson: boolean;
    courseCount: number;
    completedCourseCount: number;
    lessonCount: number;
    lessonCountWithQuiz: number;
    completedLessonCountWithQuiz: number;
    inProgressCourseCount: number;
    additionalResourceCount: number;
    subscriptionStatus?:
      | (
          | "pending"
          | "active"
          | "cancelled"
          | "expired"
          | "suspended"
          | "payment_failed"
          | "payment_coming_soon"
          | "merged"
        )
      | null;
    subscriptionId?: string | null;
    subjectDescription: string | null;
    subjectImageS3Key: string | null;
    subjectImageAlt: string | null;
  }[];
}

export interface GetCourseResponse {
  data: {
    archived?: boolean;
    /** @format uuid */
    authorId: string;
    subject: string;
    subjectCode: "MATH" | "POLISH" | "ENGLISH";
    /** @format uuid */
    schoolClassId: string;
    /** @format uuid */
    subjectId: string;
    /** @format uuid */
    teacherId: string;
    chapter: {
      /** @format uuid */
      id: string;
      title: string;
      lessons: {
        /** @format uuid */
        id: string;
        title: string;
        type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
        displayOrder: number;
        isFreemium: boolean;
        status: "not_started" | "in_progress" | "completed";
        quizQuestionCount: number | null;
      }[];
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      displayOrder: number;
      schoolClass?: string;
      quizCount?: number;
    };
    completedLessonCount?: number;
    courseLessonCount: number;
    description: string;
    isEnrolled?: boolean;
    /** @format uuid */
    id: string;
    isPublished: boolean;
    isScorm?: boolean;
    thumbnailUrl?: string;
    thumbnailAlt?: string;
    title: string;
    isCkeExam: boolean;
  };
}

export interface GetBetaCourseByIdResponse {
  data: {
    archived?: boolean;
    /** @format uuid */
    authorId: string;
    subject: string;
    subjectCode: "MATH" | "POLISH" | "ENGLISH";
    /** @format uuid */
    subjectId: string;
    /** @format uuid */
    schoolClassId?: string;
    /** @format uuid */
    teacherId: string;
    chapter: {
      /** @format uuid */
      id: string;
      title: string;
      lessons?: {
        /** @format uuid */
        id: string;
        title: string;
        type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
        description?: string | null;
        status?: string;
        displayOrder: number;
        fileUrl?: string | null;
        questions?: {
          /** @format uuid */
          id?: string;
          type:
            | "scale_1_5"
            | "single_choice"
            | "free_choice"
            | "multiple_choice"
            | "true_or_false"
            | "fill_in_the_blanks_text"
            | "fill_in_the_blanks_dnd"
            | "sorting"
            | "ai_graded_open_answer";
          description?: string | null;
          title: string;
          displayOrder?: number;
          solutionExplanation?: string | null;
          solutionKey?: string | null;
          photoS3Key?: string | null;
          photoAlt?: string | null;
          media?: {
            /** @format uuid */
            id?: string;
            type: "audio" | "text";
            s3Key?: string | null;
            content?: string | null;
            name?: string | null;
            displayOrder: number | null;
          }[];
          options?: {
            /** @format uuid */
            id?: string;
            optionText: string;
            displayOrder: number | null;
            isStudentAnswer?: boolean | null;
            isCorrect: boolean;
            /** @format uuid */
            questionId?: string;
            scaleAnswer?: number | null;
          }[];
        }[];
        /** @format date-time */
        updatedAt?: string;
        highlights?: {
          /** @format uuid */
          id?: string;
          title: string;
          photoS3Key?: string;
          photoS3Url?: string;
          timestamp: number;
          photoAlt?: string | null;
        }[];
        additionalResources?: {
          /** @format uuid */
          id?: string;
          title: string;
          fileS3Key: string;
          fileS3Url?: string;
          fileName: string;
          fileNameToDownload: string | null;
          fileExtension?: string;
          fileSize?: number | null;
          /** @format date-time */
          createdAt?: string;
        }[];
        isFreemium?: boolean;
        parentLessonId?: string | null;
      }[];
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      displayOrder: number;
      schoolClass?: string;
    };
    completedLessonCount?: number;
    courseLessonCount: number;
    description: string;
    isEnrolled?: boolean;
    /** @format uuid */
    id: string;
    isPublished: boolean;
    isScorm?: boolean;
    thumbnailUrl?: string;
    thumbnailAlt?: string | null;
    thumbnailS3Key?: string;
    thumbnailS3SignedUrl?: string | null;
    title: string;
    displayOrder: number;
  };
}

export interface GetDisplayOrderBySubjectAndSchoolClassResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    displayOrder: number;
  }[];
}

export type CreateCourseBody = {
  title: string;
  description: string;
  isPublished?: boolean;
  thumbnailS3Key?: string;
  thumbnailAlt?: string;
  /** @format uuid */
  subjectId: string;
  isScorm?: boolean;
  /** @format uuid */
  schoolClassId: string;
  /** @format uuid */
  teacherId: string;
  displayOrder: number;
} & {
  chapters?: string[];
};

export interface CreateCourseResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface DuplicateCourseBody {
  name: string;
  /** @format uuid */
  classId: string;
}

export interface DuplicateCourseResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateCourseBody {
  title?: string;
  description?: string;
  thumbnailS3Key?: string;
  thumbnailAlt?: string;
  isPublished?: boolean;
  /** @format uuid */
  subjectId?: string;
  /** @format uuid */
  teacherId?: string;
  /** @format uuid */
  schoolClassId?: string;
  chapters?: string[];
  archived?: boolean;
  displayOrder?: number;
}

export interface UpdateCourseResponse {
  data: {
    message: string;
  };
}

export interface EnrollCourseResponse {
  data: {
    message: string;
  };
}

export type UnenrollCourseResponse = null;

export type DeleteCourseResponse = null;

export type DeleteManyCoursesResponse = null;

export interface GetExamsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    description: string;
    schoolClassName: string;
    subjectName: string;
    isExamPublished: boolean;
    testType: ("SECTION_TEST" | "EXAM_SHEET" | "MOCK_EXAM") | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetStudentExamsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    description: string;
    schoolClassName: string;
    subjectName: string;
    subjectCode: string;
    testType: ("SECTION_TEST" | "EXAM_SHEET" | "MOCK_EXAM") | null;
    timeLimitMinutes: number | null;
    totalQuestions: number;
    quizScore: number | null;
    attemptStatus: "not_started" | "in_progress" | "expired_pending" | "completed";
    isEnrolled: boolean;
    questions: {
      /** @format uuid */
      id: string;
      passQuestion: boolean | null;
    }[];
  }[];
}

export interface GetLessonsWithFiltersResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    flashcardCategoryTitle: string | null;
  }[];
}

export interface GetMissingVimeoThumbnailsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    fileUrl: string;
  }[];
}

export interface GetLessonByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
    description: string | null;
    fileUrl?: string | null;
    quizDetails?: {
      questions: {
        /** @format uuid */
        id: string;
        type:
          | "scale_1_5"
          | "single_choice"
          | "free_choice"
          | "multiple_choice"
          | "true_or_false"
          | "fill_in_the_blanks_text"
          | "fill_in_the_blanks_dnd"
          | "sorting"
          | "ai_graded_open_answer";
        description?: string | null;
        title: string;
        displayOrder?: number;
        solutionExplanation: string | null;
        photoS3Key?: string | null;
        photoAlt: string | null;
        media?: {
          /** @format uuid */
          id: string;
          type: "audio" | "text";
          s3Key: string | null;
          s3Url?: string | null;
          content: string | null;
          name: string | null;
          displayOrder: number | null;
        }[];
        options?: {
          /** @format uuid */
          id: string;
          optionText: string | null;
          displayOrder: number | null;
          isStudentAnswer: boolean | null;
          studentAnswer: string | null;
          isCorrect: boolean | null;
          /** @format uuid */
          questionId?: string;
        }[];
        passQuestion: boolean | null;
        studentFeedback?: string | null;
        studentAnswers?: object | null;
        aiEvaluation?: {
          status: "completed" | "pending" | "processing" | "failed";
          percentageScore: number | null;
          feedback: string | null;
          error: string | null;
        };
      }[];
      questionCount: number;
      correctAnswerCount: number | null;
      wrongAnswerCount: number | null;
      score: number | null;
    };
    lessonCompleted?: boolean;
    quizEvaluationStatus?: "completed" | "pending" | "processing" | "failed";
    subjectCode?: "MATH" | "POLISH" | "ENGLISH";
    displayOrder: number;
    nextLessonId: string | null;
    highlights: {
      /** @format uuid */
      id?: string;
      title: string;
      photoS3Key?: string;
      photoS3Url?: string;
      timestamp: number;
      photoAlt?: string | null;
    }[];
    additionalResources: {
      /** @format uuid */
      id?: string;
      title: string;
      fileS3Key: string;
      fileS3Url?: string;
      fileName: string;
      fileNameToDownload: string | null;
      fileExtension?: string;
      fileSize?: number | null;
      /** @format date-time */
      createdAt?: string;
    }[];
    isFreemium: boolean;
    flashcardSetId: string | null;
    timeLimitMinutes?: number | null;
    deadline?: string | null;
    remainingSeconds?: number | null;
    finalizationStatus?: ("pending_expired" | "evaluation_failed") | null;
  };
}

export interface GetExamByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    description: string;
    fileUrl?: string | null;
    type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
    displayOrder: number;
    chapterId?: string | null;
    isExamPublished: boolean;
    schoolClassName: string;
    subjectName: string;
    /** @format uuid */
    subjectId: string;
    /** @format uuid */
    schoolClassId: string;
    timeLimitMinutes: number | null;
    testType: ("SECTION_TEST" | "EXAM_SHEET" | "MOCK_EXAM") | null;
  };
}

export interface FinalizeExamIfExpiredResponse {
  data: {
    status: ("pending_expired" | "evaluation_failed") | null;
  };
}

export interface SaveExamDraftAnswerBody {
  /** @format uuid */
  questionId: string;
  answers: (
    | {
        /** @format uuid */
        answerId: string;
      }
    | {
        value: string;
      }
    | {
        /** @format uuid */
        answerId: string;
        value: string;
      }
  )[];
}

export interface SaveExamDraftAnswerResponse {
  data: {
    message: string;
  };
}

export type BetaCreateLessonBody = {
  title: string;
  type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
  description?: string | null;
  status?: string;
  fileUrl?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "scale_1_5"
      | "single_choice"
      | "free_choice"
      | "multiple_choice"
      | "true_or_false"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd"
      | "sorting"
      | "ai_graded_open_answer";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string | null;
    solutionKey?: string | null;
    photoS3Key?: string | null;
    photoAlt?: string | null;
    media?: {
      /** @format uuid */
      id?: string;
      type: "audio" | "text";
      s3Key?: string | null;
      content?: string | null;
      name?: string | null;
      displayOrder: number | null;
    }[];
    options?: {
      /** @format uuid */
      id?: string;
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean;
      /** @format uuid */
      questionId?: string;
      scaleAnswer?: number | null;
    }[];
  }[];
  /** @format date-time */
  updatedAt?: string;
  highlights?: {
    /** @format uuid */
    id?: string;
    title: string;
    photoS3Key?: string;
    photoS3Url?: string;
    timestamp: number;
    photoAlt?: string | null;
  }[];
  additionalResources?: {
    /** @format uuid */
    id?: string;
    title: string;
    fileS3Key: string;
    fileS3Url?: string;
    fileName: string;
    fileNameToDownload: string | null;
    fileExtension?: string;
    fileSize?: number | null;
    /** @format date-time */
    createdAt?: string;
  }[];
  isFreemium?: boolean;
} & {
  /** @format uuid */
  chapterId: string;
  displayOrder?: number;
};

export interface BetaCreateLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export type BetaCreateQuizLessonBody = {
  title: string;
  type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
  description?: string;
  solutionExplanation?: string;
  fileUrl?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "scale_1_5"
      | "single_choice"
      | "free_choice"
      | "multiple_choice"
      | "true_or_false"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd"
      | "sorting"
      | "ai_graded_open_answer";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string | null;
    solutionKey?: string | null;
    photoS3Key?: string | null;
    photoAlt?: string | null;
    media?: {
      /** @format uuid */
      id?: string;
      type: "audio" | "text";
      s3Key?: string | null;
      content?: string | null;
      name?: string | null;
      displayOrder: number | null;
    }[];
    options?: {
      /** @format uuid */
      id?: string;
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean;
      /** @format uuid */
      questionId?: string;
      scaleAnswer?: number | null;
    }[];
  }[];
  parentLessonId?: string | null;
} & {
  /** @format uuid */
  chapterId: string;
  displayOrder?: number;
  isExamPublished?: boolean;
};

export interface BetaCreateQuizLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export type BetaUpdateQuizLessonBody = {
  title?: string;
  type?: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
  description?: string;
  solutionExplanation?: string;
  fileUrl?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "scale_1_5"
      | "single_choice"
      | "free_choice"
      | "multiple_choice"
      | "true_or_false"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd"
      | "sorting"
      | "ai_graded_open_answer";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string | null;
    solutionKey?: string | null;
    photoS3Key?: string | null;
    photoAlt?: string | null;
    media?: {
      /** @format uuid */
      id?: string;
      type: "audio" | "text";
      s3Key?: string | null;
      content?: string | null;
      name?: string | null;
      displayOrder: number | null;
    }[];
    options?: {
      /** @format uuid */
      id?: string;
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean;
      /** @format uuid */
      questionId?: string;
      scaleAnswer?: number | null;
    }[];
  }[];
  parentLessonId?: string | null;
} & {
  /** @format uuid */
  chapterId?: string;
  displayOrder?: number;
  isExamPublished?: boolean;
};

export interface BetaUpdateQuizLessonResponse {
  data: {
    message: string;
  };
}

export type BetaUpdateLessonBody = {
  title?: string;
  type?: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
  description?: string | null;
  status?: string;
  fileUrl?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "scale_1_5"
      | "single_choice"
      | "free_choice"
      | "multiple_choice"
      | "true_or_false"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd"
      | "sorting"
      | "ai_graded_open_answer";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string | null;
    solutionKey?: string | null;
    photoS3Key?: string | null;
    photoAlt?: string | null;
    media?: {
      /** @format uuid */
      id?: string;
      type: "audio" | "text";
      s3Key?: string | null;
      content?: string | null;
      name?: string | null;
      displayOrder: number | null;
    }[];
    options?: {
      /** @format uuid */
      id?: string;
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean;
      /** @format uuid */
      questionId?: string;
      scaleAnswer?: number | null;
    }[];
  }[];
  /** @format date-time */
  updatedAt?: string;
  highlights?: {
    /** @format uuid */
    id?: string;
    title: string;
    photoS3Key?: string;
    photoS3Url?: string;
    timestamp: number;
    photoAlt?: string | null;
  }[];
  additionalResources?: {
    /** @format uuid */
    id?: string;
    title: string;
    fileS3Key: string;
    fileS3Url?: string;
    fileName: string;
    fileNameToDownload: string | null;
    fileExtension?: string;
    fileSize?: number | null;
    /** @format date-time */
    createdAt?: string;
  }[];
  isFreemium?: boolean;
} & {
  /** @format uuid */
  chapterId?: string;
  displayOrder?: number;
};

export interface BetaUpdateLessonResponse {
  data: {
    message: string;
  };
}

export interface RemoveLessonResponse {
  data: {
    message: string;
  };
}

export interface TrialQuizAnswersBody {
  /** @format uuid */
  lessonId: string;
  questionsAnswers: {
    /** @format uuid */
    questionId: string;
    answers: (
      | {
          /** @format uuid */
          answerId: string;
        }
      | {
          value: string;
        }
      | {
          /** @format uuid */
          answerId: string;
          value: string;
        }
    )[];
  }[];
}

export interface TrialQuizAnswersResponse {
  data: {
    message: string;
    data: {
      correctAnswerCount: number;
      wrongAnswerCount: number;
      questionCount: number;
      score: number;
      questions: {
        /** @format uuid */
        id: string;
        type:
          | "scale_1_5"
          | "single_choice"
          | "free_choice"
          | "multiple_choice"
          | "true_or_false"
          | "fill_in_the_blanks_text"
          | "fill_in_the_blanks_dnd"
          | "sorting"
          | "ai_graded_open_answer";
        description?: string | null;
        title: string;
        displayOrder?: number;
        solutionExplanation: string | null;
        photoS3Key?: string | null;
        photoAlt: string | null;
        media?: {
          /** @format uuid */
          id: string;
          type: "audio" | "text";
          s3Key: string | null;
          s3Url?: string | null;
          content: string | null;
          name: string | null;
          displayOrder: number | null;
        }[];
        options?: {
          /** @format uuid */
          id: string;
          optionText: string | null;
          displayOrder: number | null;
          isStudentAnswer: boolean | null;
          studentAnswer: string | null;
          isCorrect: boolean | null;
          /** @format uuid */
          questionId?: string;
        }[];
        passQuestion: boolean | null;
        studentFeedback?: string | null;
        studentAnswers?: object | null;
        aiEvaluation?: {
          status: "completed" | "pending" | "processing" | "failed";
          percentageScore: number | null;
          feedback: string | null;
          error: string | null;
        };
      }[];
    };
  };
}

export interface PreviewQuizAnswersBody {
  /** @format uuid */
  lessonId: string;
  questionsAnswers: {
    /** @format uuid */
    questionId: string;
    answers: (
      | {
          /** @format uuid */
          answerId: string;
        }
      | {
          value: string;
        }
      | {
          /** @format uuid */
          answerId: string;
          value: string;
        }
    )[];
  }[];
}

export interface PreviewQuizAnswersResponse {
  data: {
    message: string;
    data: {
      correctAnswerCount: number;
      wrongAnswerCount: number;
      questionCount: number;
      score: number;
      questions: {
        /** @format uuid */
        id: string;
        type:
          | "scale_1_5"
          | "single_choice"
          | "free_choice"
          | "multiple_choice"
          | "true_or_false"
          | "fill_in_the_blanks_text"
          | "fill_in_the_blanks_dnd"
          | "sorting"
          | "ai_graded_open_answer";
        description?: string | null;
        title: string;
        displayOrder?: number;
        solutionExplanation: string | null;
        photoS3Key?: string | null;
        photoAlt: string | null;
        media?: {
          /** @format uuid */
          id: string;
          type: "audio" | "text";
          s3Key: string | null;
          s3Url?: string | null;
          content: string | null;
          name: string | null;
          displayOrder: number | null;
        }[];
        options?: {
          /** @format uuid */
          id: string;
          optionText: string | null;
          displayOrder: number | null;
          isStudentAnswer: boolean | null;
          studentAnswer: string | null;
          isCorrect: boolean | null;
          /** @format uuid */
          questionId?: string;
        }[];
        passQuestion: boolean | null;
        studentFeedback?: string | null;
        studentAnswers?: object | null;
        aiEvaluation?: {
          status: "completed" | "pending" | "processing" | "failed";
          percentageScore: number | null;
          feedback: string | null;
          error: string | null;
        };
      }[];
    };
  };
}

export interface EvaluationQuizBody {
  /** @format uuid */
  lessonId: string;
  questionsAnswers: {
    /** @format uuid */
    questionId: string;
    answers: (
      | {
          /** @format uuid */
          answerId: string;
        }
      | {
          value: string;
        }
      | {
          /** @format uuid */
          answerId: string;
          value: string;
        }
    )[];
  }[];
}

export interface EvaluationQuizResponse {
  data: {
    message: string;
    data: {
      correctAnswerCount: number;
      wrongAnswerCount: number;
      questionCount: number;
      score: number;
    };
  };
}

export interface ClearQuizProgressBody {
  /** @format uuid */
  lessonId: string;
}

export interface ClearQuizProgressResponse {
  data: {
    message: string;
  };
}

export interface UpdateLessonDisplayOrderBody {
  /** @format uuid */
  lessonId: string;
  displayOrder: number;
}

export interface UpdateLessonDisplayOrderResponse {
  data: {
    message: string;
  };
}

export interface DownloadAdditionalResourceResponse {
  data: {
    message: string;
  };
}

export interface WatchVideoEventResponse {
  data: {
    message: string;
  };
}

export interface WatchVideo70PercentEventResponse {
  data: {
    message: string;
  };
}

export interface UpdateLessonVimeoThumbnailResponse {
  data: {
    message: string;
  };
}

export interface CreateExamBody {
  title: string;
  /**
   * @minLength 1
   * @maxLength 10000
   */
  description: string;
  /** @format uuid */
  schoolClassId: string;
  /** @format uuid */
  subjectId: string;
  testType: "SECTION_TEST" | "EXAM_SHEET" | "MOCK_EXAM";
  timeLimitMinutes?: number | null;
}

export interface CreateExamResponse {
  data: {
    message: string;
  };
}

export interface UpdateExamBody {
  title?: string;
  /**
   * @minLength 1
   * @maxLength 10000
   */
  description?: string;
  /** @format uuid */
  schoolClassId?: string;
  /** @format uuid */
  subjectId?: string;
  isExamPublished?: boolean;
  testType?: "SECTION_TEST" | "EXAM_SHEET" | "MOCK_EXAM";
  timeLimitMinutes?: number | null;
}

export interface UpdateExamResponse {
  data: {
    message: string;
  };
}

export interface DuplicateLessonBody {
  name: string;
  /** @format uuid */
  courseId: string;
}

export interface DuplicateLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface ListLessonsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    subjectId: string | null;
    subjectName: string | null;
    schoolClassId: string | null;
    schoolClassName: string | null;
    chapterId: string | null;
    chapterTitle: string | null;
    courseId: string | null;
    courseTitle: string | null;
    authorId: string | null;
    authorName: string | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface ListAttemptsResponse {
  data: {
    /** @format uuid */
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    completedAt: string | null;
    quizScore: number | null;
    aiRollup: {
      total: number;
      notGraded: number;
      aiFailed: number;
    };
  }[];
}

export interface GetAttemptReviewResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    type: "VIDEO" | "TEXT" | "QUIZ" | "EXAM";
    description: string | null;
    fileUrl?: string | null;
    quizDetails?: {
      questions: {
        /** @format uuid */
        id: string;
        type:
          | "scale_1_5"
          | "single_choice"
          | "free_choice"
          | "multiple_choice"
          | "true_or_false"
          | "fill_in_the_blanks_text"
          | "fill_in_the_blanks_dnd"
          | "sorting"
          | "ai_graded_open_answer";
        description?: string | null;
        title: string;
        displayOrder?: number;
        solutionExplanation: string | null;
        photoS3Key?: string | null;
        photoAlt: string | null;
        media?: {
          /** @format uuid */
          id: string;
          type: "audio" | "text";
          s3Key: string | null;
          s3Url?: string | null;
          content: string | null;
          name: string | null;
          displayOrder: number | null;
        }[];
        options?: {
          /** @format uuid */
          id: string;
          optionText: string | null;
          displayOrder: number | null;
          isStudentAnswer: boolean | null;
          studentAnswer: string | null;
          isCorrect: boolean | null;
          /** @format uuid */
          questionId?: string;
        }[];
        passQuestion: boolean | null;
        studentFeedback?: string | null;
        studentAnswers?: object | null;
        aiEvaluation?: {
          status: "completed" | "pending" | "processing" | "failed";
          percentageScore: number | null;
          feedback: string | null;
          error: string | null;
        };
      }[];
      questionCount: number;
      correctAnswerCount: number | null;
      wrongAnswerCount: number | null;
      score: number | null;
    };
    lessonCompleted?: boolean;
    quizEvaluationStatus?: "completed" | "pending" | "processing" | "failed";
    subjectCode?: "MATH" | "POLISH" | "ENGLISH";
    displayOrder: number;
    nextLessonId: string | null;
    highlights: {
      /** @format uuid */
      id?: string;
      title: string;
      photoS3Key?: string;
      photoS3Url?: string;
      timestamp: number;
      photoAlt?: string | null;
    }[];
    additionalResources: {
      /** @format uuid */
      id?: string;
      title: string;
      fileS3Key: string;
      fileS3Url?: string;
      fileName: string;
      fileNameToDownload: string | null;
      fileExtension?: string;
      fileSize?: number | null;
      /** @format date-time */
      createdAt?: string;
    }[];
    isFreemium: boolean;
    flashcardSetId: string | null;
    timeLimitMinutes?: number | null;
    deadline?: string | null;
    remainingSeconds?: number | null;
    finalizationStatus?: ("pending_expired" | "evaluation_failed") | null;
  };
}

export interface GenerateQuizBody {
  /** @format uuid */
  chapterId?: string;
  /**
   * @minLength 1
   * @maxLength 25000
   */
  topic: string;
  /** @maxLength 100 */
  subject?: string;
  /** @maxLength 50 */
  schoolClass?: string;
  testType?: "SECTION_TEST" | "EXAM_SHEET" | "MOCK_EXAM";
  /**
   * @min 1
   * @max 50
   */
  questionCount: number;
  questionTypes: (
    | "true_or_false"
    | "single_choice"
    | "multiple_choice"
    | "free_choice"
    | "fill_in_the_blanks_text"
    | "fill_in_the_blanks_dnd"
    | "sorting"
  )[];
  /**
   * @min 0
   * @max 10
   */
  aiGradedCount: number;
}

export interface GenerateQuizResponse {
  /** @format uuid */
  jobId: string;
}

export interface CancelJobResponse {
  status: string;
}

export interface GetJobResponse {
  status: string;
  title: string | null;
  plan: {
    /** @min 0 */
    index: number;
    aspect: string;
    type: string;
  }[];
  questions: (
    | {
        type:
          | "true_or_false"
          | "single_choice"
          | "multiple_choice"
          | "free_choice"
          | "fill_in_the_blanks_text"
          | "fill_in_the_blanks_dnd"
          | "sorting";
        /**
         * @minLength 1
         * @maxLength 500
         */
        title: string;
        /** @maxLength 10000 */
        description?: string;
        sourceText?: string;
        /** @minLength 1 */
        solutionExplanation: string;
        /** @minItems 1 */
        options: {
          /** @maxLength 200 */
          optionText: string;
          isCorrect: boolean;
          /** @min 0 */
          displayOrder: number;
        }[];
      }
    | {
        type: "ai_graded_open_answer";
        /**
         * @minLength 1
         * @maxLength 500
         */
        title: string;
        /** @maxLength 10000 */
        description?: string;
        sourceText?: string;
        /**
         * @minLength 40
         * @maxLength 3000
         */
        solutionKey: string;
        /** @minLength 20 */
        solutionExplanation: string;
      }
  )[];
  usage: {
    inputTokens: number;
    cachedInputTokens: number;
    outputTokens: number;
  } | null;
  costUsd: number | null;
  error: string | null;
}

export type ListResponse = {
  key: string;
  label: string;
  sections: {
    key: string;
    label: string;
    editable: boolean;
    content: string;
    isOverridden: boolean;
  }[];
}[];

export interface UpdateBody {
  /**
   * @minLength 1
   * @maxLength 64
   */
  promptKey: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  sectionKey: string;
  /** @maxLength 50000 */
  content: string;
}

export interface UpdateResponse {
  success: boolean;
}

export interface ResetBody {
  /**
   * @minLength 1
   * @maxLength 64
   */
  promptKey: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  sectionKey: string;
}

export interface ResetResponse {
  success: boolean;
}

export type Body = object;

export interface SearchResponse {
  data: {
    /** @format uuid */
    id: string;
    lessonTitle: string;
    description: string | null;
    vimeoThumbnailUrl: string | null;
    subjectName: string;
    /** @format uuid */
    subjectId: string;
    schoolClassName: string;
    /** @format uuid */
    schoolClassId: string;
    isFreemium: boolean;
    isEnrolled: boolean;
    /** @format uuid */
    courseId: string;
    courseName: string;
    courseLessonCount: number;
    lessonDisplayOrder: number;
  }[];
}

export interface SearchHistoryResponse {
  data: {
    /** @format uuid */
    id: string;
    lessonTitle: string;
    description: string | null;
    vimeoThumbnailUrl: string | null;
    subjectName: string;
    /** @format uuid */
    subjectId: string;
    schoolClassName: string;
    /** @format uuid */
    schoolClassId: string;
    isFreemium: boolean;
    isEnrolled: boolean;
    /** @format uuid */
    courseId: string;
    courseName: string;
    courseLessonCount: number;
    lessonDisplayOrder: number;
  }[];
}

export interface GetStudentPreferencesResponse {
  data: {
    data: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      studentId: string;
      preferredSubject: string | null;
      classLevel: string | null;
      learningGoals: string[] | null;
      completedAt: string | null;
    };
    message: string;
  };
}

export interface CreateStudentPreferencesBody {
  preferredSubject: string;
  classLevel: string;
  learningGoals: string[];
}

export interface CreateStudentPreferencesResponse {
  data: {
    message: string;
  };
}

export interface GetAllSchoolClassesResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  }[];
}

export interface GetSchoolClassByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
  };
}

export interface GetAllTeachersResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    firstName: string;
    lastName: string;
    description: string;
    profilePictureS3Key: string | null;
    profilePictureAlt: string | null;
    subjectId: string | null;
    educationalMission: string;
    profilePictureS3SignedUrl: string | null;
    assignedCourseCount: number;
    subjectName: string | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetTeacherByIdResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    firstName: string;
    lastName: string;
    description: string;
    profilePictureS3Key: string | null;
    profilePictureAlt: string | null;
    subjectId: string | null;
    educationalMission: string;
    profilePictureS3SignedUrl: string | null;
    subjectName: string;
  };
}

export interface CreateTeacherBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  firstName: string;
  lastName: string;
  description: string;
  profilePictureS3Key?: string | null;
  profilePictureAlt?: string | null;
  subjectId?: string | null;
  educationalMission: string;
}

export interface CreateTeacherResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateTeacherBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  firstName?: string;
  lastName?: string;
  description?: string;
  profilePictureS3Key?: string | null;
  profilePictureAlt?: string | null;
  subjectId?: string | null;
  educationalMission?: string;
}

export interface UpdateTeacherResponse {
  data: {
    message: string;
  };
}

export interface DeleteTeacherResponse {
  data: {
    message: string;
  };
}

export interface GetAllSubscriptionPlansResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    price: number;
    oldPrice: number | null;
    weeklyPrice: number | null;
    weeklyOldPrice: number | null;
    /** @format date-time */
    createdAt: string;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetSubscriptionPlanByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    price: number;
    oldPrice: number | null;
    weeklyPrice: number | null;
    weeklyOldPrice: number | null;
    /** @format date-time */
    createdAt: string;
  };
}

export interface UpdateSubscriptionPlanBody {
  price?: number;
  oldPrice?: number;
  weeklyPrice?: number;
  weeklyOldPrice?: number;
}

export interface UpdateSubscriptionPlanResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    price: number;
    oldPrice: number | null;
    weeklyPrice: number | null;
    weeklyOldPrice: number | null;
    /** @format date-time */
    createdAt: string;
  };
}

export interface GetSubscriptionsByStudentIdResponse {
  data: {
    planName: string;
    status: string;
    amount: number;
    transactionId: string;
    subscriptions: {
      /** @format uuid */
      id: string;
      subject: string;
      className: string;
      startDate: string;
      endDate: string | null;
      cancellationDate: string | null;
      nextRenewalDate: string | null;
    }[];
  }[];
}

export interface GetGuardianChildrenSubscriptionsResponse {
  data: {
    id: string | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    subscriptions: {
      /** @format uuid */
      id: string;
      studentId: string | null;
      /** @format uuid */
      subscriptionClassId: string;
      startDate: string | null;
      endDate: string | null;
      cancellationDate: string | null;
      nextRenewalDate: string | null;
      promotionEndDate: string | null;
      amount: number;
      basePrice: number | null;
      currency: string | null;
      transactionId: string | null;
      status:
        | "pending"
        | "active"
        | "cancelled"
        | "expired"
        | "suspended"
        | "payment_failed"
        | "payment_coming_soon"
        | "merged";
      interval: string;
      nextInterval: string | null;
      subscriptionPlanId: string | null;
      subscriptionSubjectIds: string[];
      subjectCodes: ("MATH" | "POLISH" | "ENGLISH")[];
      subjectTitle: string | null;
      schoolClassName: string | null;
      cardMask: string | null;
      cardType: string | null;
      paymentMethodType: string | null;
      blikAliasStatus: string | null;
      failedPaymentAttempts: number;
      discountCode?: string | null;
      discountPercentage?: number | null;
      discountValidUntil?: string | null;
      discountExpirationDate?: string | null;
      discountRenewalCycles?: number | null;
      discountCyclesUsed?: number | null;
      discountRegulationUrl?: string | null;
    }[];
    oneTimeAccesses?: {
      /** @format uuid */
      id: string;
      subjectIds: string[];
      subjectCodes: ("MATH" | "POLISH" | "ENGLISH")[];
      /** @format uuid */
      schoolClassId: string;
      schoolClassName: string | null;
      startDate: string;
      endDate: string;
      status: string;
      createdAt: string;
      paymentMethod: {
        id: number;
        name: string;
        imgUrl: string | null;
      } | null;
    }[];
  }[];
}

export interface GetActivationInfoResponse {
  data: {
    email: string;
    subjects: string[];
    amount: number;
    expiresAt: string;
    isValid: boolean;
    message: string;
  };
}

export interface ActivateSubscriptionBody {
  token: string;
  /** @format uuid */
  userId: string;
  studentToken?: string;
}

export interface ActivateSubscriptionResponse {
  data: {
    success: boolean;
    message: string;
    subscriptionsCreated: number;
  };
}

export interface CheckAutoRenewalsResponse {
  data: {
    message: string;
  };
}

export interface AdminListSubscriptionsResponse {
  data: {
    /** @format uuid */
    id: string;
    studentFirstName: string | null;
    studentLastName: string | null;
    studentEmail: string;
    guardianEmail: string;
    schoolClassName: string | null;
    subjects: string | null;
    interval: string;
    nextInterval: string | null;
    intervalSwitchedAt: string | null;
    status: string;
    startDate: string | null;
    endDate: string | null;
    cancellationDate: string | null;
    amount: number;
    paymentMethodType: string | null;
    blikAliasStatus: string | null;
    failedPaymentAttempts: number;
    nextPaymentRetryAt: string | null;
    createdAt: string;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface AdminWeeklyConversionResponse {
  data: {
    weeklyPurchased: number;
    switchedToMonthly: number;
    scheduledSwitches: number;
    activeWeekly: number;
    conversionRate: number;
  };
}

export interface AdminSubscriptionHistoryResponse {
  data: {
    payments: {
      date: string;
      amount: number;
      status: string;
      purpose: string | null;
    }[];
    events: {
      type: string;
      date: string;
      details: string | null;
    }[];
  };
}

export interface RestoreSubscriptionBody {
  /** @format uuid */
  transactionId: string;
  /** @format uuid */
  studentClassId: string;
}

export interface RestoreSubscriptionResponse {
  data: {
    success: boolean;
    message: string;
    restoredSubscriptions: number;
  };
}

export interface UpdateSubscriptionPaymentMethodBody {
  cardRefId: string;
  cardMask?: string;
  cardType?: string;
}

export interface UpdateSubscriptionPaymentMethodResponse {
  data: {
    success: boolean;
    cardMask?: string;
    cardType?: string;
  };
}

export interface SwitchToMonthlyResponse {
  data: {
    success: boolean;
    message: string;
    effectiveDate: string | null;
    monthlyAmount: number | null;
  };
}

export interface IntervalSwitchPreviewResponse {
  data: {
    /** @format uuid */
    subscriptionId: string;
    /** @format uuid */
    schoolClassId: string;
    schoolClassName: string;
    subjects: {
      /** @format uuid */
      id: string;
      title: string;
    }[];
    monthlyBasePrice: number;
    monthlyAmount: number;
    unusedCredit: number;
    chargeAmount: number;
    remainingDays: number;
    periodDays: number;
    currency: string;
    cardMask: string | null;
    discount: {
      code: string;
      percentage: number;
    } | null;
    merge: {
      /** @format uuid */
      subscriptionId: string;
      renewalDate: string | null;
      extraDays: number;
    } | null;
  };
}

export interface IntervalSwitchBody {
  /** @pattern ^[0-9]{6}$ */
  blikCode?: string;
  marketingEmailConsent?: boolean;
}

export interface IntervalSwitchResponse {
  data: {
    applied: boolean;
    sessionId: string | null;
  };
}

export interface SendReactivationRequestBody {
  /** @format uuid */
  subscriptionId: string;
}

export interface SendReactivationRequestResponse {
  data: {
    success: boolean;
    message: string;
  };
}

export type HandleBlikAliasWebhookBody =
  | {
      data: {
        orderId: number;
        sessionId: string;
        method?: number;
        result?: any;
        sign?: string;
        [key: string]: any;
      };
    }
  | {
      orderId: number;
      sessionId: string;
      method?: number;
      result?: any;
      sign?: string;
      [key: string]: any;
    }
  | {
      email: string;
      value: string;
      type?: string;
      status: string;
    };

export interface GetPaymentsHistoryByGuardianIdResponse {
  data: {
    id: string;
    student: {
      id: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string;
    };
    subjects: {
      id: string;
      title: string;
      code: "MATH" | "POLISH" | "ENGLISH";
    }[];
    period: {
      startDate: string;
      endDate: string;
    };
    status: string;
    amount: number;
    cardMask: string | null;
    cardType: string | null;
    interval: string | null;
    purpose: string | null;
    paymentMethod: {
      id: number;
      name: string;
      imgUrl: string | null;
    } | null;
    createdAt: string;
    schoolClassName: string;
    discountInfo: {
      code: string;
      percentage: number;
      validUntil: string | null;
    } | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface CancelSubscriptionBody {
  /** @format uuid */
  transactionId: string;
  subscriptionSubjectIds: string[];
  /** @format uuid */
  studentClassId: string;
}

export interface CancelSubscriptionResponse {
  data: {
    success: boolean;
    cancelledSubscriptions: number;
    cancelledTransactions: number;
  };
}

export interface GetTransactionBySessionIdResponse {
  data: {
    /** @format uuid */
    sessionId: string;
    userId: string | null;
    amount: number;
    subscriptionSubjectIds: string[];
    /** @format uuid */
    subscriptionClassId: string;
    subscriptionPlanId: string | null;
    status: string;
    schoolClassName: string | null;
    studentEmail: string | null;
    hasOtherSubscriptions: boolean;
  };
}

export interface GetGamificationBadgesResponse {
  data: {
    id: string;
    name: string;
    badgeType: string;
    trophyType: string;
    tier: number;
    schoolClassName: string | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetGamificationBadgeByIdResponse {
  data: {
    id: string;
    name: string;
    tier: number;
    completedTierName: string;
    badgeAvatarId: string | null;
    description: string | null;
    descriptionAfterShare: string | null;
    subjectIds: string[] | null;
    badgeType:
      | "POWER_SIGN"
      | "LEARNING_TROPHY"
      | "BIDIRECTIONAL_TROPHY"
      | "INTERDISCIPLINARY_TROPHY";
    trophyType:
      | "STARTER"
      | "SOCIAL_MOTIVATOR"
      | "MOTIVATION_AMBASSADOR"
      | "LESSON_SPRINTER"
      | "DAILY_RECORD_HOLDER"
      | "VIRTUAL_EXPLORER"
      | "PERSISTENT_WANDERER"
      | "CONSTRUCTIVE_REVIEWER"
      | "MATH_MASTER"
      | "POLISH_MASTER"
      | "ENGLISH_MASTER"
      | "MATH_QUIZ_MARATHONER"
      | "POLISH_QUIZ_MARATHONER"
      | "ENGLISH_QUIZ_MARATHONER"
      | "MATH_PRECISE_MIND"
      | "POLISH_PRECISE_MIND"
      | "ENGLISH_PRECISE_MIND"
      | "MATH_FLAWLESS_MIND"
      | "POLISH_FLAWLESS_MIND"
      | "ENGLISH_FLAWLESS_MIND"
      | "MATH_VIDEO_ENTHUSIAST"
      | "POLISH_VIDEO_ENTHUSIAST"
      | "ENGLISH_VIDEO_ENTHUSIAST"
      | "MATH_DIDACTIC_COLLECTOR"
      | "POLISH_DIDACTIC_COLLECTOR"
      | "ENGLISH_DIDACTIC_COLLECTOR"
      | "TWO_SUBJECT_MASTER_MAT_ENG"
      | "TWO_SUBJECT_MASTER_MAT_POL"
      | "TWO_SUBJECT_MASTER_ENG_POL"
      | "TWO_SECTION_EXPERT_MAT_ENG"
      | "TWO_SECTION_EXPERT_MAT_POL"
      | "TWO_SECTION_EXPERT_ENG_POL"
      | "QUIZ_DUO_MAT_ENG"
      | "QUIZ_DUO_MAT_POL"
      | "QUIZ_DUO_ENG_POL"
      | "FLAWLESS_DUO_MAT_ENG"
      | "FLAWLESS_DUO_MAT_POL"
      | "FLAWLESS_DUO_ENG_POL"
      | "VIDEO_DUO_MAT_ENG"
      | "VIDEO_DUO_MAT_POL"
      | "VIDEO_DUO_ENG_POL"
      | "DIDACTIC_DUO_MAT_ENG"
      | "DIDACTIC_DUO_MAT_POL"
      | "DIDACTIC_DUO_ENG_POL"
      | "THREE_SUBJECT_MASTER"
      | "THREE_SECTION_EXPERT"
      | "QUIZ_TRIATHLON"
      | "FLAWLESS_TRIO"
      | "VIDEO_TRIAD"
      | "DIDACTIC_TRIAD";
    schoolClassName: string | null;
    subjectCodes: ("MATH" | "POLISH" | "ENGLISH")[] | null;
  };
}

export interface UpdateGamificationBadgeBody {
  name: string;
  description: string | null;
  descriptionAfterShare: string | null;
}

export interface UpdateGamificationBadgeResponse {
  data: {
    id: string;
    name: string;
    badgeType: string;
    trophyType: string;
    tier: number;
    schoolClassName: string | null;
  };
}

export interface GetUserAchievementsResponse {
  data: {
    achievedBadgeCount: number;
    gamificationBadges: {
      id: string | null;
      /** @format uuid */
      achievementBadgeId: string;
      name: string;
      badgeType:
        | "POWER_SIGN"
        | "LEARNING_TROPHY"
        | "BIDIRECTIONAL_TROPHY"
        | "INTERDISCIPLINARY_TROPHY";
      trophyType:
        | "STARTER"
        | "SOCIAL_MOTIVATOR"
        | "MOTIVATION_AMBASSADOR"
        | "LESSON_SPRINTER"
        | "DAILY_RECORD_HOLDER"
        | "VIRTUAL_EXPLORER"
        | "PERSISTENT_WANDERER"
        | "CONSTRUCTIVE_REVIEWER"
        | "MATH_MASTER"
        | "POLISH_MASTER"
        | "ENGLISH_MASTER"
        | "MATH_QUIZ_MARATHONER"
        | "POLISH_QUIZ_MARATHONER"
        | "ENGLISH_QUIZ_MARATHONER"
        | "MATH_PRECISE_MIND"
        | "POLISH_PRECISE_MIND"
        | "ENGLISH_PRECISE_MIND"
        | "MATH_FLAWLESS_MIND"
        | "POLISH_FLAWLESS_MIND"
        | "ENGLISH_FLAWLESS_MIND"
        | "MATH_VIDEO_ENTHUSIAST"
        | "POLISH_VIDEO_ENTHUSIAST"
        | "ENGLISH_VIDEO_ENTHUSIAST"
        | "MATH_DIDACTIC_COLLECTOR"
        | "POLISH_DIDACTIC_COLLECTOR"
        | "ENGLISH_DIDACTIC_COLLECTOR"
        | "TWO_SUBJECT_MASTER_MAT_ENG"
        | "TWO_SUBJECT_MASTER_MAT_POL"
        | "TWO_SUBJECT_MASTER_ENG_POL"
        | "TWO_SECTION_EXPERT_MAT_ENG"
        | "TWO_SECTION_EXPERT_MAT_POL"
        | "TWO_SECTION_EXPERT_ENG_POL"
        | "QUIZ_DUO_MAT_ENG"
        | "QUIZ_DUO_MAT_POL"
        | "QUIZ_DUO_ENG_POL"
        | "FLAWLESS_DUO_MAT_ENG"
        | "FLAWLESS_DUO_MAT_POL"
        | "FLAWLESS_DUO_ENG_POL"
        | "VIDEO_DUO_MAT_ENG"
        | "VIDEO_DUO_MAT_POL"
        | "VIDEO_DUO_ENG_POL"
        | "DIDACTIC_DUO_MAT_ENG"
        | "DIDACTIC_DUO_MAT_POL"
        | "DIDACTIC_DUO_ENG_POL"
        | "THREE_SUBJECT_MASTER"
        | "THREE_SECTION_EXPERT"
        | "QUIZ_TRIATHLON"
        | "FLAWLESS_TRIO"
        | "VIDEO_TRIAD"
        | "DIDACTIC_TRIAD";
      tier: number;
      badgeAvatarId: string | null;
      nextBadgeAvatarId: string | null;
      descriptionAfterShare: string;
      dateOfAchieved: string | null;
      progress: number;
      requiredProgress: number;
      descriptionRequiredProgress: number;
      schoolClassName: string | null;
      subjectCodes: ("MATH" | "POLISH" | "ENGLISH")[] | null;
      missingSubjectCodes: ("MATH" | "POLISH" | "ENGLISH")[] | null;
    }[];
  };
}

export interface GetSharedAchievementResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    badgeType:
      | "POWER_SIGN"
      | "LEARNING_TROPHY"
      | "BIDIRECTIONAL_TROPHY"
      | "INTERDISCIPLINARY_TROPHY";
    trophyType:
      | "STARTER"
      | "SOCIAL_MOTIVATOR"
      | "MOTIVATION_AMBASSADOR"
      | "LESSON_SPRINTER"
      | "DAILY_RECORD_HOLDER"
      | "VIRTUAL_EXPLORER"
      | "PERSISTENT_WANDERER"
      | "CONSTRUCTIVE_REVIEWER"
      | "MATH_MASTER"
      | "POLISH_MASTER"
      | "ENGLISH_MASTER"
      | "MATH_QUIZ_MARATHONER"
      | "POLISH_QUIZ_MARATHONER"
      | "ENGLISH_QUIZ_MARATHONER"
      | "MATH_PRECISE_MIND"
      | "POLISH_PRECISE_MIND"
      | "ENGLISH_PRECISE_MIND"
      | "MATH_FLAWLESS_MIND"
      | "POLISH_FLAWLESS_MIND"
      | "ENGLISH_FLAWLESS_MIND"
      | "MATH_VIDEO_ENTHUSIAST"
      | "POLISH_VIDEO_ENTHUSIAST"
      | "ENGLISH_VIDEO_ENTHUSIAST"
      | "MATH_DIDACTIC_COLLECTOR"
      | "POLISH_DIDACTIC_COLLECTOR"
      | "ENGLISH_DIDACTIC_COLLECTOR"
      | "TWO_SUBJECT_MASTER_MAT_ENG"
      | "TWO_SUBJECT_MASTER_MAT_POL"
      | "TWO_SUBJECT_MASTER_ENG_POL"
      | "TWO_SECTION_EXPERT_MAT_ENG"
      | "TWO_SECTION_EXPERT_MAT_POL"
      | "TWO_SECTION_EXPERT_ENG_POL"
      | "QUIZ_DUO_MAT_ENG"
      | "QUIZ_DUO_MAT_POL"
      | "QUIZ_DUO_ENG_POL"
      | "FLAWLESS_DUO_MAT_ENG"
      | "FLAWLESS_DUO_MAT_POL"
      | "FLAWLESS_DUO_ENG_POL"
      | "VIDEO_DUO_MAT_ENG"
      | "VIDEO_DUO_MAT_POL"
      | "VIDEO_DUO_ENG_POL"
      | "DIDACTIC_DUO_MAT_ENG"
      | "DIDACTIC_DUO_MAT_POL"
      | "DIDACTIC_DUO_ENG_POL"
      | "THREE_SUBJECT_MASTER"
      | "THREE_SECTION_EXPERT"
      | "QUIZ_TRIATHLON"
      | "FLAWLESS_TRIO"
      | "VIDEO_TRIAD"
      | "DIDACTIC_TRIAD";
    tier: number;
    completedTierName: string;
    badgeAvatarId: string | null;
    description: string | null;
    descriptionAfterShare: string | null;
    awardedAt: string;
    subjectIds: string[] | null;
    subjectCodes: ("MATH" | "POLISH" | "ENGLISH")[] | null;
    schoolClassName: string | null;
  };
}

export type ListMessagesResponse = {
  content: string;
  role: "system" | "user" | "assistant";
}[];

export type GetUserThreadsResponse = {
  threadId: string;
  /** @format uuid */
  lessonId: string;
}[];

export interface GetThreadByLessonResponse {
  threadId: string | null;
}

export interface GetUserThreadIdResponse {
  userThreadId: string | null;
}

export interface GetTokenUsageResponse {
  systemPromptTokens: number;
  aiMaterialsTokens: number;
  historyTokens: number;
  totalTokens: number;
  maxTokens: number;
  percentageUsed: number;
}

export interface CreateThreadResponse {
  threadId: string;
}

export interface Data {
  content: string;
}

export interface CreateAnonymousMessageResponse {
  role: string;
  content: string;
}

export interface CreateMessageBody {
  content: string;
}

export interface CreateMessageResponse {
  content: string;
  role: "system" | "user" | "assistant";
}

export interface DeleteLessonThreadsResponse {
  data: {
    message: string;
  };
}

export type GetPricingResponse = {
  subjectCount: number;
  price: number;
  /** @format uuid */
  schoolClassId: string;
  schoolClassName: string | null;
}[];

export interface InitPurchaseResponse {
  sessionId: string;
  redirectUrl: string;
}

export interface ActivateAccessBody {
  activationToken: string;
}

export interface RegisterBuyerBody {
  buyerToken: string;
}

export type GetMyAccessesResponse = {
  /** @format uuid */
  id: string;
  subjectIds: string[];
  /** @format uuid */
  schoolClassId: string;
  schoolClassName: string | null;
  startDate: string;
  endDate: string;
  status: string;
  createdAt: string;
  subjectNames: string[];
}[];

export interface GetBlikTransactionStatusResponse {
  sessionId: string;
  status: string;
  amount: number;
  studentEmail: string;
  buyerEmail: string;
  subjectIds: string[];
  /** @format uuid */
  schoolClassId: string;
  schoolClassName: string | null;
  paymentMethod: {
    id: number;
    name: string;
    imgUrl: string | null;
    category: "fast" | "slow";
  } | null;
}

export type GetActiveAccessesByEmailResponse = {
  /** @format uuid */
  subjectId: string;
  subjectTitle: string;
  endDate: string;
}[];

export interface GetUserFriendsInvitationsResponse {
  data: {
    id: string;
    createdAt: string;
    senderId: string;
    invitedEmail: string;
    message: string | null;
    accepted: boolean | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface CreateFriendInvitationBody {
  invitedEmail: string;
  message?: string;
}

export interface CreateFriendInvitationResponse {
  data: {
    message: string;
  };
}

export interface GetEventHistoryResponse {
  data: {
    /** @format uuid */
    id: string;
    author: string | null;
    eventType: string;
    affectedElementName: string;
    /** @format date-time */
    createdAt: string;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetSystemMessagesResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    authorId: string | null;
    title: string;
    content: string;
    targetRole: string | null;
    url: string | null;
    subjectId: string | null;
    schoolClassId: string | null;
    readCount: number;
    sentCount: number;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface CreateSystemMessageBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  title: string;
  content: string;
  targetRole?: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
  url?: string | null;
  /** @format uuid */
  subjectId?: string;
  /** @format uuid */
  schoolClassId?: string;
}

export interface CreateSystemMessageResponse {
  data: {
    message: string;
  };
}

export type GetUserSystemMessagesResponse = {
  /** @format uuid */
  id: string;
  title: string;
  content: string;
  read: boolean;
  url: string | null;
}[];

export interface MarkAllAsReadResponse {
  data: {
    message: string;
  };
}

export interface HasUnreadSystemMessageResponse {
  data: {
    hasUnreadSystemMessage: boolean;
  };
}

export interface GetPublishedFlashcardCategoriesResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
    isEnrolled: boolean;
    subjectCode: ("MATH" | "POLISH" | "ENGLISH") | null;
    subjectTitle: string;
    schoolClassName: string;
    authorName: string;
    flashcardCount: number;
    completedFlashcardCount: number;
    lessonId: string | null;
    courseId: string | null;
    lessonDisplayOrder: number | null;
    courseDisplayOrder: number | null;
    isFreemium: boolean | null;
  }[];
}

export interface GetPublishedFlashcardCategoryByIdResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
    isEnrolled: boolean;
    subjectCode: ("MATH" | "POLISH" | "ENGLISH") | null;
    subjectTitle: string;
    schoolClassName: string;
    authorName: string;
    flashcardCount: number;
    completedFlashcardCount: number;
    lessonId: string | null;
    courseId: string | null;
    lessonDisplayOrder: number | null;
    courseDisplayOrder: number | null;
    isFreemium: boolean | null;
  };
}

export interface GetAllFlashcardCategoriesResponse {
  data: {
    id: string;
    createdAt: string;
    /** @maxLength 200 */
    title: string;
    isPublished: boolean;
    subjectTitle: string;
    schoolClassName: string;
    authorName: string;
    flashcardCount: number;
    lessonTitle: string | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetUserFavoriteFlashcardsResponse {
  data: {
    imageUrl: string | null;
    reverseImageUrl: string | null;
    /** @format uuid */
    id: string;
    title: string;
    answer: string;
    /** @format uuid */
    flashcardCategoryId?: string;
    isCompleted: boolean;
    isFavorite: boolean;
    subjectCode: "MATH" | "POLISH" | "ENGLISH";
    imageAlt: string | null;
    reverseImageAlt: string | null;
  }[];
}

export interface GetFlashcardCategoryResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
    lessonId: string | null;
  };
}

export interface GetPublishedFlashcardsForCategoryStudentResponse {
  data: {
    imageUrl: string | null;
    reverseImageUrl: string | null;
    /** @format uuid */
    id: string;
    title: string;
    answer: string;
    isCompleted: boolean;
    isFavorite: boolean;
    subjectCode: "MATH" | "POLISH" | "ENGLISH";
    imageAlt: string | null;
    reverseImageAlt: string | null;
  }[];
}

export interface GetFlashcardsForCategoryResponse {
  data: (({
    id: string;
    createdAt: string;
    title: string;
    answer: string;
    imageAlt: string | null;
    reverseImageAlt: string | null;
  } & {
    authorName: string;
    imageAlt: string | null;
    reverseImageAlt: string | null;
  }) & {
    imageUrl: string | null;
    reverseImageUrl: string | null;
  })[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetFlashcardResponse {
  data: ({
    id: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    answer: string;
    imageS3Key: string | null;
    imageAlt: string | null;
    flashcardCategoryId: string;
    authorId: string;
    reverseImageS3Key: string | null;
    reverseImageAlt: string | null;
  } & {
    authorName: string;
    isFavorite: boolean;
    imageAlt: string | null;
    reverseImageAlt: string | null;
  }) & {
    imageUrl: string | null;
    reverseImageUrl: string | null;
  };
}

export interface CreateFlashcardCategoryBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  /** @maxLength 200 */
  title: string;
  subjectId: string;
  schoolClassId: string;
  isPublished?: boolean;
  lessonId?: string | null;
}

export interface CreateFlashcardCategoryResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
    lessonId: string | null;
  };
}

export interface AddFavoriteFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface CompleteFlashcardResponse {
  data: {
    message: string;
  };
}

export interface CreateFlashcardBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  title: string;
  answer: string;
  imageS3Key?: string | null;
  imageAlt?: string | null;
  flashcardCategoryId: string;
  reverseImageS3Key?: string | null;
  reverseImageAlt?: string | null;
}

export interface CreateFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateFlashcardCategoryBody {
  /** @maxLength 200 */
  title?: string;
  subjectId?: string;
  schoolClassId?: string;
  lessonId?: string | null;
}

export interface UpdateFlashcardCategoryResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @maxLength 200 */
    title: string;
    subjectId: string;
    schoolClassId: string;
    authorId: string;
    isPublished: boolean;
    lessonId: string | null;
  };
}

export interface TogglePublishFlashcardCategoryResponse {
  data: boolean;
}

export interface UpdateFlashcardBody {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  title: string;
  answer: string;
  imageS3Key?: string | null;
  imageAlt?: string | null;
  flashcardCategoryId: string;
  reverseImageS3Key?: string | null;
  reverseImageAlt?: string | null;
}

export interface UpdateFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface DeleteFlashcardCategoryResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface DeleteFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface RemoveFavoriteFlashcardResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface ResetFlashcardProgressResponse {
  data: {
    message: string;
  };
}

export interface GetCandidatesResponse {
  data: {
    id: string;
    studentId: string | null;
    studentEmail: string;
    studentName: string;
    guardianEmail: string;
    guardianName: string | null;
    guardianEmailSource: string;
    subjectTitles: string;
    planNames: string | null;
    amount: number | null;
    currency: string | null;
    class7EndDate: string | null;
    emailSentAt: string | null;
    emailSentCount: number;
    confirmedAt: string | null;
    classMigrated: boolean;
  }[];
}

export interface SendBody {
  all?: boolean;
  studentKeys?: string[];
}

export interface SendResponse {
  data: {
    sent: number;
    failed: number;
    candidates: {
      id: string;
      studentId: string | null;
      studentEmail: string;
      studentName: string;
      guardianEmail: string;
      guardianName: string | null;
      guardianEmailSource: string;
      subjectTitles: string;
      planNames: string | null;
      amount: number | null;
      currency: string | null;
      class7EndDate: string | null;
      emailSentAt: string | null;
      emailSentCount: number;
      confirmedAt: string | null;
      classMigrated: boolean;
    }[];
  };
}

export interface ConfirmBody {
  guardianEmail: string;
  studentEmail: string;
}

export interface ConfirmResponse {
  data: {
    success: boolean;
  };
}

export interface GetAllSubjectDescriptionsResponse {
  data: {
    data: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      subjectId: string;
      /** @format uuid */
      schoolClassId: string;
      description: string;
      imageS3Key: string;
      imageAlt: string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      updatedAt: string;
      subjectTitle: string | null;
      schoolClassName: string | null;
    }[];
    pagination: {
      totalItems: number;
      totalPages?: number;
      page: number;
      perPage: number;
    };
  };
}

export interface GetSubjectDescriptionByIdResponse {
  data: {
    data: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      subjectId: string;
      /** @format uuid */
      schoolClassId: string;
      description: string;
      imageS3Key: string;
      imageAlt: string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      updatedAt: string;
      subjectTitle: string | null;
      schoolClassName: string | null;
    };
  };
}

export interface CreateSubjectDescriptionBody {
  /** @format uuid */
  subjectId: string;
  /** @format uuid */
  schoolClassId: string;
  description: string;
  imageS3Key: string;
  imageAlt: string;
}

export interface CreateSubjectDescriptionResponse {
  data: {
    data: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      subjectId: string;
      /** @format uuid */
      schoolClassId: string;
      description: string;
      imageS3Key: string;
      imageAlt: string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      updatedAt: string;
      subjectTitle: string | null;
      schoolClassName: string | null;
    };
  };
}

export interface UpdateSubjectDescriptionBody {
  /** @format uuid */
  subjectId?: string;
  /** @format uuid */
  schoolClassId?: string;
  description?: string;
  imageS3Key?: string;
  imageAlt?: string;
}

export interface UpdateSubjectDescriptionResponse {
  data: {
    data: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      subjectId: string;
      /** @format uuid */
      schoolClassId: string;
      description: string;
      imageS3Key: string;
      imageAlt: string;
      /** @format date-time */
      createdAt: string;
      /** @format date-time */
      updatedAt: string;
      subjectTitle: string | null;
      schoolClassName: string | null;
    };
  };
}

export type DeleteSubjectDescriptionResponse = null;

export interface GetFeatureFlagsResponse {
  data: object;
}

export interface GetSubjectsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    code: string | null;
  }[];
}

export interface GetTutorsResponse {
  data: {
    /** @format uuid */
    tutorSubjectId: string;
    /** @format uuid */
    tutorId: string;
    name: string;
    bio: string | null;
    profilePictureUrl: string | null;
    priceGrosze: number;
    durationMinutes: number;
  }[];
}

export interface GetAvailabilityResponse {
  data: {
    slots: {
      start: string;
      /** @format uuid */
      tutorSubjectId: string;
      /** @format uuid */
      tutorId: string;
      tutorName: string;
      tutorProfilePictureUrl: string | null;
      priceGrosze: number;
      durationMinutes: number;
    }[];
  };
}

export interface GetTutorProfileResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    bio: string | null;
    rating: number | null;
    review: string | null;
    profilePictureUrl: string | null;
  };
}

export interface GetTutorSubjectResponse {
  data: {
    /** @format uuid */
    tutorSubjectId: string;
    /** @format uuid */
    tutorId: string;
    tutorName: string;
    tutorProfilePictureUrl: string | null;
    /** @format uuid */
    subjectId: string;
    subjectTitle: string;
    subjectCode: string | null;
    priceGrosze: number;
    durationMinutes: number;
  };
}

export interface RegisterTransactionResponse {
  data: {
    /** @format uuid */
    bookingId: string;
    sessionId: string;
    redirectUrl: string;
    reservationExpiresAt: string;
  };
}

export interface UpdateTopicBody {
  /** @maxLength 500 */
  topic: string;
}

export interface UpdateTopicResponse {
  data: {
    /** @format uuid */
    id: string;
    topic: string;
  };
}

export interface GetMyBookingsResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
    startsAt: string;
    endsAt: string;
    priceGrosze: number;
    topic: string | null;
    meetingUrl: string | null;
    isRefunded: boolean;
    refundRequired: boolean;
    cancelledBy: "student" | "guardian" | null;
    /** @format uuid */
    studentId: string;
    studentName: string;
    /** @format uuid */
    tutorId: string;
    tutorName: string;
    tutorProfilePictureUrl: string | null;
    /** @format uuid */
    subjectId: string;
    subjectTitle: string;
  }[];
}

export interface GetGuardianBookingsResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
    startsAt: string;
    endsAt: string;
    priceGrosze: number;
    topic: string | null;
    meetingUrl: string | null;
    isRefunded: boolean;
    refundRequired: boolean;
    cancelledBy: "student" | "guardian" | null;
    /** @format uuid */
    studentId: string;
    studentName: string;
    /** @format uuid */
    tutorId: string;
    tutorName: string;
    tutorProfilePictureUrl: string | null;
    /** @format uuid */
    subjectId: string;
    subjectTitle: string;
  }[];
}

export interface GetGuardianBookableOptionsResponse {
  data: {
    /** @format uuid */
    studentId: string;
    studentName: string;
    /** @format uuid */
    subjectId: string;
    subjectTitle: string;
    schoolClassName: string;
    bookable: boolean;
  }[];
}

export interface GetBookableSubjectsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    code: string | null;
    schoolClassName: string;
    bookable: boolean;
  }[];
}

export interface GetNextSlotsResponse {
  data: {
    /** @format uuid */
    subjectId: string;
    subjectTitle: string;
    subjectCode: string | null;
    start: string;
    /** @format uuid */
    tutorSubjectId: string;
    /** @format uuid */
    tutorId: string;
    tutorName: string;
    tutorProfilePictureUrl: string | null;
    priceGrosze: number;
    durationMinutes: number;
  }[];
}

export interface GetBookingStatusResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
    startsAt: string;
    endsAt: string;
    subjectTitle: string;
    subjectCode: string | null;
    meetingUrl: string | null;
    reservationExpiresAt: string | null;
  };
}

export interface CancelBookingResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
    eligibleForRefund: boolean;
  };
}

export interface RescheduleBookingBody {
  startsAt: string;
}

export interface RescheduleBookingResponse {
  data: {
    /** @format uuid */
    id: string;
    startsAt: string;
    endsAt: string;
  };
}

export interface RequestTutorCancellationRefundResponse {
  data: {
    /** @format uuid */
    id: string;
    refundRequired: boolean;
  };
}

export interface RebookAfterTutorCancellationBody {
  /** @format uuid */
  tutorSubjectId: string;
  startsAt: string;
}

export interface RebookAfterTutorCancellationResponse {
  data: {
    /** @format uuid */
    id: string;
    startsAt: string;
    endsAt: string;
  };
}

export interface GetBookingNoteResponse {
  data: {
    /** @format uuid */
    bookingId: string;
    note: {
      summary: string;
      covered: string[];
      remember: string[];
      practice: string[];
    } | null;
    createdAt: string | null;
  };
}

export interface ListTutorsResponse {
  data: {
    /** @format uuid */
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    bio: string | null;
    rating: number | null;
    review: string | null;
    profilePictureS3Key: string | null;
    calcomUserId: number | null;
    calcomUsername: string | null;
    teacherId: string | null;
    teacherName: string | null;
    active: boolean;
    subjects: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      subjectId: string;
      subjectTitle: string;
      calcomEventTypeId: number;
      priceGrosze: number;
      durationMinutes: number;
    }[];
  }[];
}

export interface GetTutorResponse {
  data: {
    /** @format uuid */
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    bio: string | null;
    rating: number | null;
    review: string | null;
    profilePictureS3Key: string | null;
    profilePictureUrl: string | null;
    calcomUserId: number | null;
    calcomUsername: string | null;
    teacherId: string | null;
    active: boolean;
    subjects: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      subjectId: string;
      subjectTitle: string;
      calcomEventTypeId: number;
      priceGrosze: number;
      durationMinutes: number;
    }[];
    upcomingBookingsCount: number;
  };
}

export interface CreateTutorBody {
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /** @format email */
  email: string;
  bio?: string | null;
  rating?: number | null;
  review?: string | null;
  profilePictureS3Key?: string | null;
  calcomUserId?: number | null;
  calcomUsername?: string | null;
  teacherId?: string | null;
  active?: boolean;
}

export interface CreateTutorResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface UpdateTutorBody {
  /** @minLength 1 */
  firstName?: string;
  /** @minLength 1 */
  lastName?: string;
  /** @format email */
  email?: string;
  bio?: string | null;
  rating?: number | null;
  review?: string | null;
  profilePictureS3Key?: string | null;
  calcomUserId?: number | null;
  calcomUsername?: string | null;
  teacherId?: string | null;
  active?: boolean;
}

export interface UpdateTutorResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface ListEventTypesResponse {
  data: {
    id: number;
    title: string;
    lengthInMinutes: number;
    ownerId: number;
  }[];
}

export interface AddTutorSubjectBody {
  /** @format uuid */
  subjectId: string;
  /** @min 1 */
  calcomEventTypeId: number;
  /** @min 1 */
  priceGrosze: number;
  /** @min 1 */
  durationMinutes: number;
}

export interface AddTutorSubjectResponse {
  data: {
    /** @format uuid */
    id: string;
    /** @format uuid */
    subjectId: string;
    calcomEventTypeId: number;
    priceGrosze: number;
    durationMinutes: number;
  };
}

export interface UpdateTutorSubjectBody {
  /** @min 1 */
  calcomEventTypeId?: number;
  /** @min 1 */
  priceGrosze?: number;
  /** @min 1 */
  durationMinutes?: number;
}

export interface UpdateTutorSubjectResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface DeleteTutorSubjectResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface ListLessonsMissingNoteResponse {
  data: {
    /** @format uuid */
    id: string;
    startsAt: string;
    endsAt: string;
    topic: string | null;
    subjectTitle: string;
    studentEmail: string;
    tutorName: string;
  }[];
}

export interface ListBookingsResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
    startsAt: string;
    endsAt: string;
    topic: string | null;
    priceGrosze: number;
    meetingUrl: string | null;
    paidAt: string | null;
    cancelledAt: string | null;
    refundRequired: boolean;
    refundedAt: string | null;
    studentName: string;
    studentEmail: string;
    /** @format uuid */
    tutorId: string;
    tutorName: string;
    subjectTitle: string;
    hasNote: boolean;
  }[];
}

export interface GetBookingResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
    startsAt: string;
    endsAt: string;
    topic: string | null;
    priceGrosze: number;
    meetingUrl: string | null;
    paidAt: string | null;
    cancelledAt: string | null;
    refundRequired: boolean;
    refundedAt: string | null;
    studentName: string;
    studentEmail: string;
    /** @format uuid */
    tutorId: string;
    tutorName: string;
    subjectTitle: string;
    hasNote: boolean;
    note: {
      summary: string;
      covered: string[];
      remember: string[];
      practice: string[];
    } | null;
  };
}

export interface ListRefundsResponse {
  data: {
    /** @format uuid */
    id: string;
    startsAt: string;
    cancelledAt: string | null;
    priceGrosze: number;
    status: string;
    p24SessionId: string;
    p24OrderId: number | null;
    studentEmail: string;
    subjectTitle: string;
    tutorName: string;
  }[];
}

export interface MarkRefundedResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface ListReportsResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    createdAt: string;
    byteSize: number;
    authorName: string | null;
    config: {
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      from: string;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      to: string;
      schoolClassIds: string[];
      subjectIds: string[];
      /** @minItems 1 */
      sheets: {
        key:
          | "learning"
          | "quizResults"
          | "searches"
          | "achievements"
          | "subscriptions"
          | "subscriptionRetention"
          | "weeklyRenewals"
          | "weeklyToMonthly"
          | "payments"
          | "oneTimeAccesses"
          | "tutoring"
          | "discountCodes"
          | "accounts"
          | "abandonedCarts"
          | "paymentErrors";
        /** @minItems 1 */
        columns: string[];
        filters?: Record<string, string>;
      }[];
    };
    thumbnailUrl: string | null;
  }[];
}

export interface CreateReportResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface ListReportTemplatesResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    config: {
      /**
       * @min 0
       * @max 3650
       */
      periodDays: number;
      schoolClassIds: string[];
      subjectIds: string[];
      /** @minItems 1 */
      sheets: {
        key:
          | "learning"
          | "quizResults"
          | "searches"
          | "achievements"
          | "subscriptions"
          | "subscriptionRetention"
          | "weeklyRenewals"
          | "weeklyToMonthly"
          | "payments"
          | "oneTimeAccesses"
          | "tutoring"
          | "discountCodes"
          | "accounts"
          | "abandonedCarts"
          | "paymentErrors";
        /** @minItems 1 */
        columns: string[];
        filters?: Record<string, string>;
      }[];
    };
    createdAt: string;
  }[];
}

export interface CreateReportTemplateBody {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  config: {
    /**
     * @min 0
     * @max 3650
     */
    periodDays: number;
    schoolClassIds: string[];
    subjectIds: string[];
    /** @minItems 1 */
    sheets: {
      key:
        | "learning"
        | "quizResults"
        | "searches"
        | "achievements"
        | "subscriptions"
        | "subscriptionRetention"
        | "weeklyRenewals"
        | "weeklyToMonthly"
        | "payments"
        | "oneTimeAccesses"
        | "tutoring"
        | "discountCodes"
        | "accounts"
        | "abandonedCarts"
        | "paymentErrors";
      /** @minItems 1 */
      columns: string[];
      filters?: Record<string, string>;
    }[];
  };
}

export interface CreateReportTemplateResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface DeleteReportTemplateResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface DeleteReportResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface GetLearningReportRowsResponse {
  data: {
    studentName: string;
    email: string;
    registeredAt: string;
    schoolClass: string;
    subject: string;
    learningDays: number;
    lastActivityAt: string | null;
    videosWatched: number;
    quizzesSolved: number;
    quizAverageScore: number | null;
    testsSolved: number;
    testAverageScore: number | null;
    aiQuestions: number;
    flashcardsReviewed: number;
    materialsDownloaded: number;
    watchTimeMinutes: number;
    videosWatchedTotal: number;
    videoLessonsInSubject: number;
  }[];
}

export interface GetQuizResultsReportRowsResponse {
  data: {
    studentName: string;
    email: string;
    schoolClass: string | null;
    subject: string | null;
    lessonTitle: string;
    lessonType: string;
    score: number;
    correctAnswers: number;
    wrongAnswers: number;
    completedAt: string;
  }[];
}

export interface GetSearchesReportRowsResponse {
  data: {
    studentName: string;
    email: string;
    phrase: string;
    lessonTitle: string;
    schoolClass: string | null;
    subject: string | null;
    searchedAt: string;
  }[];
}

export interface GetAchievementsReportRowsResponse {
  data: {
    studentName: string;
    email: string;
    badgeName: string;
    tierName: string;
    tier: number;
    schoolClass: string | null;
    subjects: string | null;
    awardedAt: string;
  }[];
}

export interface GetSubscriptionsReportRowsResponse {
  data: {
    studentName: string | null;
    studentEmail: string;
    guardianEmail: string;
    schoolClass: string;
    subjects: string | null;
    interval: string;
    status: string;
    startDate: string | null;
    endDate: string | null;
    cancellationDate: string | null;
    amount: number;
    basePrice: number;
    discountCode: string | null;
    discountCyclesUsed: number;
    paymentMethod: string | null;
    failedPaymentAttempts: number;
    nextPaymentRetryAt: string | null;
    activatedAt: string | null;
    createdAt: string;
  }[];
}

export interface GetSubscriptionRetentionReportRowsResponse {
  data: {
    metric:
      | "weeklyCancelledAfterFirstWeek"
      | "weeklyAutoRenewed"
      | "weeklySwitchedToMonthly"
      | "monthlyRenewed";
    users: number;
    totalUsers: number;
    percent: number | null;
    averagePaidWeeks: number | null;
  }[];
}

export interface GetWeeklyRenewalsReportRowsResponse {
  data: {
    studentName: string | null;
    studentEmail: string;
    schoolClass: string;
    subjects: string | null;
    purchasedAt: string;
    renewalDates: string;
    paidWeeks: number;
    isActive: boolean;
  }[];
}

export interface GetWeeklyToMonthlyReportRowsResponse {
  data: {
    studentName: string | null;
    studentEmail: string;
    schoolClass: string;
    subjects: string | null;
    purchasedAt: string;
    weeklyRenewalDates: string | null;
    switchedAt: string;
    monthlyRenewalDates: string | null;
  }[];
}

export interface GetPaymentsReportRowsResponse {
  data: {
    /** @format uuid */
    id: string;
    paidAt: string;
    paymentType: "subscription" | "oneTimeBlik" | "tutoring";
    purpose: string | null;
    interval: string | null;
    status: string;
    amount: number;
    payerEmail: string | null;
    studentEmail: string | null;
    schoolClass: string | null;
    subjects: string | null;
    discountCode: string | null;
    paymentMethod: string | null;
    orderId: string | null;
    refundedAt: string | null;
  }[];
}

export interface GetOneTimeAccessesReportRowsResponse {
  data: {
    studentName: string | null;
    studentEmail: string;
    buyerEmail: string;
    schoolClass: string;
    subjects: string | null;
    startDate: string;
    endDate: string;
    status: string;
    amount: number | null;
    discountCode: string | null;
    createdAt: string;
  }[];
}

export interface GetTutoringReportRowsResponse {
  data: {
    studentName: string;
    studentEmail: string;
    buyerEmail: string | null;
    tutorName: string;
    subject: string;
    startsAt: string;
    endsAt: string;
    status: string;
    price: number;
    topic: string | null;
    paidAt: string | null;
    cancelledAt: string | null;
    refundRequired: boolean;
    refundedAt: string | null;
    hasNote: boolean;
  }[];
}

export interface GetDiscountCodesReportRowsResponse {
  data: {
    code: string;
    name: string;
    discountPercentage: number;
    codeType: string;
    usageCount: number;
    maxUsageCount: number | null;
    isActive: boolean;
    expirationDate: string | null;
    validUntil: string | null;
    renewalCycles: number | null;
    schoolClasses: string | null;
    ownerEmail: string | null;
    createdAt: string;
  }[];
}

export interface GetAccountsReportRowsResponse {
  data: {
    name: string;
    email: string;
    role: string;
    registeredAt: string;
    freeAccess: boolean;
    emailConsent: boolean;
    guardianEmailConsent: boolean | null;
    phoneConsent: boolean;
    contactPhone: string | null;
    linkedAccounts: string | null;
    linkedAccountsSource: string | null;
    hasActiveAccess: boolean;
    accessEndedAt: string | null;
    everPurchased: boolean;
    firstPurchaseAt: string | null;
    lastPurchaseAt: string | null;
    lastActivityAt: string | null;
    ghostAccount: boolean;
  }[];
}

export interface GetAbandonedCartsReportRowsResponse {
  data: {
    guardianEmail: string;
    schoolClass: string;
    startedAt: string;
    completedAt: string | null;
    abandonedTagSentAt: string | null;
    status: string;
  }[];
}

export interface GetPaymentErrorsReportRowsResponse {
  data: {
    createdAt: string;
    errorType: string;
    errorCode: string | null;
    errorMessage: string;
    source: string;
    sourceMethod: string | null;
    guardianEmail: string | null;
    studentEmail: string | null;
    amount: number | null;
    schoolClass: string | null;
    subjects: string | null;
    orderId: string | null;
    sessionId: string | null;
    resolved: boolean;
    resolvedAt: string | null;
    notes: string | null;
  }[];
}

export interface GetPaymentsResponse {
  data: {
    /** @format uuid */
    id: string;
    paidAt: string;
    paymentType: "subscription" | "oneTimeBlik" | "tutoring";
    purpose: string | null;
    interval: string | null;
    status: string;
    amount: number;
    payerEmail: string | null;
    studentEmail: string | null;
    schoolClass: string | null;
    subjects: string | null;
    discountCode: string | null;
    paymentMethod: string | null;
    orderId: string | null;
    refundedAt: string | null;
  }[];
  pagination: {
    totalItems: number;
    totalPages?: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
  availableFiltersBody?: object;
}

export interface GetPaymentsSummaryResponse {
  data: {
    paidAmount: number;
    paidCount: number;
    breakdown: {
      segment:
        | "subscriptionInitial"
        | "subscriptionRenewal"
        | "subscriptionTopUp"
        | "oneTimeBlik"
        | "tutoring";
      amount: number;
      count: number;
    }[];
    timeline: {
      granularity: "day" | "week" | "month";
      buckets: {
        period: string;
        subscription: number;
        oneTimeBlik: number;
        tutoring: number;
      }[];
    };
  };
}

export interface ExportPaymentsResponse {
  data: {
    /** @format uuid */
    id: string;
    paidAt: string;
    paymentType: "subscription" | "oneTimeBlik" | "tutoring";
    purpose: string | null;
    interval: string | null;
    status: string;
    amount: number;
    payerEmail: string | null;
    studentEmail: string | null;
    schoolClass: string | null;
    subjects: string | null;
    discountCode: string | null;
    paymentMethod: string | null;
    orderId: string | null;
    refundedAt: string | null;
  }[];
}

export interface SetPaymentRefundBody {
  refunded: boolean;
}

export interface SetPaymentRefundResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface GetDashboardResponse {
  data: {
    period: {
      from: string;
      to: string;
    };
    attention: {
      tutoringRefunds: number;
      tutoringRefundsAmount: number;
      renewalRetries: number;
      pendingSubscriptions: number;
      tutoringMissingNotes: number;
      aiGradingIssues: number;
      failedEmails: number;
    };
    sales: {
      payments: {
        paidAmount: number;
        paidCount: number;
        breakdown: {
          segment:
            | "subscriptionInitial"
            | "subscriptionRenewal"
            | "subscriptionTopUp"
            | "oneTimeBlik"
            | "tutoring";
          amount: number;
          count: number;
        }[];
        timeline: {
          granularity: "day" | "week" | "month";
          buckets: {
            period: string;
            subscription: number;
            oneTimeBlik: number;
            tutoring: number;
          }[];
        };
      };
      failedPayments: number;
      activeSubscriptions: number;
      newSubscriptions: number;
      cancelledSubscriptions: number;
      expiredUnpaidSubscriptions: number;
      weeklyConversion: {
        weeklyPurchased: number;
        switchedToMonthly: number;
        scheduledSwitches: number;
        activeWeekly: number;
        conversionRate: number;
      };
      abandonedCarts: number;
    };
    users: {
      newStudents: number;
      newGuardians: number;
      unverified: number;
    };
    learning: {
      studentsWithAccess: number;
      activeStudents: number;
      quizzesSolved: number;
      quizAverageScore: number | null;
      testsSolved: number;
      testAverageScore: number | null;
      videosWatched: number;
      aiQuestions: number;
    };
    tutoring: {
      upcoming: number;
      completed: number;
      cancelled: number;
    };
  };
}

export interface GetStudentsResponse {
  data: {
    /** @format uuid */
    studentId: string;
    firstName: string;
    firstNameGenitive: string;
    lastName: string;
    products: {
      /** @format uuid */
      schoolClassId: string;
      schoolClassName: string;
      /** @format uuid */
      subjectId: string;
      subjectTitle: string;
    }[];
  }[];
}

export interface GetProgressResponse {
  data: {
    daysCollected: number;
    period: {
      from: string;
      to: string;
      activeDays: number;
      watchedVideoLessons: number;
      solvedQuizzes: number;
      lessons: {
        /** @format uuid */
        lessonId: string;
        title: string;
        status: "started" | "good" | "average" | "weak";
        strongest: boolean;
        quizScore: number | null;
        watchedMinutes: number;
        videoCompleted: boolean;
        materials: boolean | null;
        quiz: boolean | null;
      }[];
      sectionTests: {
        /** @format uuid */
        lessonId: string;
        title: string;
        score: number;
      }[];
      mockExams: {
        /** @format uuid */
        lessonId: string;
        title: string;
        correctAnswers: number;
        questionCount: number;
        solveMinutes: number | null;
        timeLimitMinutes: number | null;
      }[];
    } | null;
    declineAlert: {
      drop: number;
      recentTestCount: number;
      weakestTest: {
        title: string;
        score: number;
      } | null;
    } | null;
    tiles: {
      startedVideoLessons: {
        value: number;
        change: number;
      };
      quizAverage: {
        value: number | null;
        change: number | null;
      };
      sectionTestAverage: {
        value: number | null;
        change: number | null;
      };
      lastMockExam: {
        correctAnswers: number;
        questionCount: number;
        change: number | null;
      } | null;
    };
  };
}

export interface GetThresholdsResponse {
  data: {
    /**
     * @min 0
     * @max 99
     */
    greenAboveScore: number;
    /**
     * @min 0
     * @max 99
     */
    redMaxScore: number;
    /**
     * @min 1
     * @max 100
     */
    testAverageDrop: number;
  };
}

export interface SaveThresholdsBody {
  /**
   * @min 0
   * @max 99
   */
  greenAboveScore: number;
  /**
   * @min 0
   * @max 99
   */
  redMaxScore: number;
  /**
   * @min 1
   * @max 100
   */
  testAverageDrop: number;
}

export interface SaveThresholdsResponse {
  data: {
    /**
     * @min 0
     * @max 99
     */
    greenAboveScore: number;
    /**
     * @min 0
     * @max 99
     */
    redMaxScore: number;
    /**
     * @min 1
     * @max 100
     */
    testAverageDrop: number;
  };
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Guidebook API
 * @version 1.0
 * @contact
 *
 * Example usage of Swagger with Typebox
 */
export class API<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @name SentEmailsControllerGetSentEmails
     * @request GET:/api/admin/sent-emails
     */
    sentEmailsControllerGetSentEmails: (
      query?: {
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSentEmailsResponse, any>({
        path: `/api/admin/sent-emails`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SentEmailsControllerGetSentEmail
     * @request GET:/api/admin/sent-emails/{id}
     */
    sentEmailsControllerGetSentEmail: (id: string, params: RequestParams = {}) =>
      this.request<GetSentEmailResponse, any>({
        path: `/api/admin/sent-emails/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerUploadFile
     * @request POST:/api/file
     */
    fileControllerUploadFile: (
      data: {
        /** @format binary */
        file?: File;
        /** Optional resource type */
        resource?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FileUploadResponse, any>({
        path: `/api/file`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerDeleteFile
     * @request DELETE:/api/file
     */
    fileControllerDeleteFile: (
      query: {
        /** Key of the file to delete */
        fileKey: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/file`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUsers
     * @request GET:/api/user/all
     */
    userControllerGetUsers: (
      query?: {
        keyword?: string;
        role?: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
        authenticationType?: "EMAIL" | "GOOGLE" | "FACEBOOK" | "TIKTOK";
        group?: "STAFF" | "USERS";
        activationStatus?: "active" | "inactive";
        subjectClassCombinations?: string;
        schoolClassIds?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUsersResponse, any>({
        path: `/api/user/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetAllUsers
     * @request GET:/api/user/all-users
     */
    userControllerGetAllUsers: (
      query?: {
        keyword?: string;
        role?: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN";
        authenticationType?: "EMAIL" | "GOOGLE" | "FACEBOOK" | "TIKTOK";
        group?: "STAFF" | "USERS";
        activationStatus?: "active" | "inactive";
        subjectClassCombinations?: string;
        schoolClassIds?: string;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllUsersResponse, any>({
        path: `/api/user/all-users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetStaffUsers
     * @request GET:/api/user/staff
     */
    userControllerGetStaffUsers: (params: RequestParams = {}) =>
      this.request<GetStaffUsersResponse, any>({
        path: `/api/user/staff`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserById
     * @request GET:/api/user
     */
    userControllerGetUserById: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserByIdResponse, any>({
        path: `/api/user`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpdateUser
     * @request PATCH:/api/user
     */
    userControllerUpdateUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      data: UpdateUserBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserResponse, any>({
        path: `/api/user`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerDeleteBulkUsers
     * @request DELETE:/api/user
     */
    userControllerDeleteBulkUsers: (data: DeleteBulkUsersBody, params: RequestParams = {}) =>
      this.request<DeleteBulkUsersResponse, any>({
        path: `/api/user`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerCreateUser
     * @request POST:/api/user
     */
    userControllerCreateUser: (data: CreateUserBody, params: RequestParams = {}) =>
      this.request<CreateUserResponse, any>({
        path: `/api/user`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerSentryTest
     * @request GET:/api/user/test-sentry
     */
    userControllerSentryTest: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/user/test-sentry`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserAvatars
     * @request GET:/api/user/avatars
     */
    userControllerGetUserAvatars: (params: RequestParams = {}) =>
      this.request<GetUserAvatarsResponse, any>({
        path: `/api/user/avatars`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpdateUserAvatar
     * @request PATCH:/api/user/avatar
     */
    userControllerUpdateUserAvatar: (
      query?: {
        userAvatarId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserAvatarResponse, any>({
        path: `/api/user/avatar`,
        method: "PATCH",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserDetails
     * @request GET:/api/user/details
     */
    userControllerGetUserDetails: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserDetailsResponse, any>({
        path: `/api/user/details`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpsertUserDetails
     * @request PATCH:/api/user/details
     */
    userControllerUpsertUserDetails: (data: UpsertUserDetailsBody, params: RequestParams = {}) =>
      this.request<UpsertUserDetailsResponse, any>({
        path: `/api/user/details`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetStudentsCsv
     * @request GET:/api/user/csv/students
     */
    userControllerGetStudentsCsv: (params: RequestParams = {}) =>
      this.request<GetStudentsCsvResponse, any>({
        path: `/api/user/csv/students`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpdateMyData
     * @request PATCH:/api/user/my-data
     */
    userControllerUpdateMyData: (data: UpdateMyDataBody, params: RequestParams = {}) =>
      this.request<UpdateMyDataResponse, any>({
        path: `/api/user/my-data`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpsertStudentDetails
     * @request PATCH:/api/user/student-details
     */
    userControllerUpsertStudentDetails: (
      data: UpsertStudentDetailsBody,
      params: RequestParams = {},
    ) =>
      this.request<UpsertStudentDetailsResponse, any>({
        path: `/api/user/student-details`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerAdminUpdateUser
     * @request PATCH:/api/user/admin
     */
    userControllerAdminUpdateUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      data: AdminUpdateUserBody,
      params: RequestParams = {},
    ) =>
      this.request<AdminUpdateUserResponse, any>({
        path: `/api/user/admin`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerBanUser
     * @request PATCH:/api/user/ban
     */
    userControllerBanUser: (data: BanUserBody, params: RequestParams = {}) =>
      this.request<BanUserResponse, any>({
        path: `/api/user/ban`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerChangePassword
     * @request PATCH:/api/user/change-password
     */
    userControllerChangePassword: (
      query: {
        /** @format uuid */
        id: string;
      },
      data: ChangePasswordBody,
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordResponse, any>({
        path: `/api/user/change-password`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerArchiveUser
     * @request PATCH:/api/user/archive
     */
    userControllerArchiveUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ArchiveUserResponse, any>({
        path: `/api/user/archive`,
        method: "PATCH",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerDeleteUser
     * @request DELETE:/api/user/user
     */
    userControllerDeleteUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserResponse, any>({
        path: `/api/user/user`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerDeleteUserById
     * @request DELETE:/api/user/user/{id}
     */
    userControllerDeleteUserById: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/user/user/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthGet
     * @request GET:/api/better-auth/*
     */
    betterAuthControllerHandleAuthGet: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthPost
     * @request POST:/api/better-auth/*
     */
    betterAuthControllerHandleAuthPost: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthPut
     * @request PUT:/api/better-auth/*
     */
    betterAuthControllerHandleAuthPut: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthDelete
     * @request DELETE:/api/better-auth/*
     */
    betterAuthControllerHandleAuthDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthPatch
     * @request PATCH:/api/better-auth/*
     */
    betterAuthControllerHandleAuthPatch: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthOptions
     * @request OPTIONS:/api/better-auth/*
     */
    betterAuthControllerHandleAuthOptions: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthHead
     * @request HEAD:/api/better-auth/*
     */
    betterAuthControllerHandleAuthHead: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "HEAD",
        ...params,
      }),

    /**
     * No description
     *
     * @name BetterAuthControllerHandleAuthSearch
     * @request SEARCH:/api/better-auth/*
     */
    betterAuthControllerHandleAuthSearch: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/better-auth/*`,
        method: "SEARCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name DevicesControllerSendVerificationEmail
     * @request POST:/api/devices/send-verification-email
     */
    devicesControllerSendVerificationEmail: (data: DeviceInfo, params: RequestParams = {}) =>
      this.request<SendVerificationEmailResponse, any>({
        path: `/api/devices/send-verification-email`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DevicesControllerVerifyDevice
     * @request POST:/api/devices/verify
     */
    devicesControllerVerifyDevice: (
      query?: {
        /** @format uuid */
        deviceId?: string;
        /** @format uuid */
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VerifyDeviceResponse, any>({
        path: `/api/devices/verify`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WebsocketControllerSendToUser
     * @request POST:/api/websocket/send-to-user/{userId}
     */
    websocketControllerSendToUser: (
      userId: string,
      data: SendToUserBody,
      params: RequestParams = {},
    ) =>
      this.request<SendToUserResponse, any>({
        path: `/api/websocket/send-to-user/${userId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WebsocketControllerSendToRole
     * @request POST:/api/websocket/send-to-role/{role}
     */
    websocketControllerSendToRole: (
      role: "ADMIN" | "STUDENT" | "CONTENT_CREATOR" | "GUARDIAN",
      data: SendToRoleBody,
      params: RequestParams = {},
    ) =>
      this.request<SendToRoleResponse, any>({
        path: `/api/websocket/send-to-role/${role}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WebsocketControllerSendToAll
     * @request POST:/api/websocket/send-to-all
     */
    websocketControllerSendToAll: (data: SendToAllBody, params: RequestParams = {}) =>
      this.request<SendToAllResponse, any>({
        path: `/api/websocket/send-to-all`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentLessonProgressControllerMarkLessonAsCompleted
     * @request POST:/api/studentLessonProgress
     */
    studentLessonProgressControllerMarkLessonAsCompleted: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MarkLessonAsCompletedResponse, any>({
        path: `/api/studentLessonProgress`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name VideoLessonMetadataControllerGetVideoProgress
     * @request GET:/api/video-lesson-metadata/video-progress
     */
    videoLessonMetadataControllerGetVideoProgress: (
      query?: {
        /** @format uuid */
        lessonId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVideoProgressResponse, any>({
        path: `/api/video-lesson-metadata/video-progress`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name VideoLessonMetadataControllerGetVideoStatistics
     * @request GET:/api/video-lesson-metadata/video-statistics
     */
    videoLessonMetadataControllerGetVideoStatistics: (
      query?: {
        /** @format uuid */
        lessonId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVideoStatisticsResponse, any>({
        path: `/api/video-lesson-metadata/video-statistics`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StatisticsControllerGetUserStatistics
     * @request GET:/api/statistics/user-stats
     */
    statisticsControllerGetUserStatistics: (params: RequestParams = {}) =>
      this.request<GetUserStatisticsResponse, any>({
        path: `/api/statistics/user-stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StatisticsControllerGetUserLessonCompletionStats
     * @request GET:/api/statistics/lesson-completion-stats
     */
    statisticsControllerGetUserLessonCompletionStats: (
      query: {
        subjectId: string;
        schoolClassIds: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserLessonCompletionStatsResponse, any>({
        path: `/api/statistics/lesson-completion-stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StatisticsControllerGetUserWeeklyStats
     * @request GET:/api/statistics/weekly-stats
     */
    statisticsControllerGetUserWeeklyStats: (
      query: {
        schoolClassIds: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserWeeklyStatsResponse, any>({
        path: `/api/statistics/weekly-stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerGetTokenizationConfig
     * @request GET:/api/purchase/tokenization-config
     */
    purchaseControllerGetTokenizationConfig: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/purchase/tokenization-config`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerInitPurchase
     * @request POST:/api/purchase/init
     */
    purchaseControllerInitPurchase: (data: InitPurchaseBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/purchase/init`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerRegisterTransaction
     * @request POST:/api/purchase/register-transaction
     */
    purchaseControllerRegisterTransaction: (
      data: RegisterTransactionBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/purchase/register-transaction`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerRegisterBlikRecurring
     * @request POST:/api/purchase/register-blik-recurring
     */
    purchaseControllerRegisterBlikRecurring: (
      data: RegisterBlikRecurringBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/purchase/register-blik-recurring`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerReauthorizeBlik
     * @request POST:/api/purchase/reauthorize-blik
     */
    purchaseControllerReauthorizeBlik: (data: ReauthorizeBlikBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/purchase/reauthorize-blik`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerExecutePayment
     * @request POST:/api/purchase/execute
     */
    purchaseControllerExecutePayment: (data: ExecutePaymentBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/purchase/execute`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerHandleWebhook
     * @request POST:/api/purchase/webhook
     */
    purchaseControllerHandleWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/purchase/webhook`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerRegisterGuardian
     * @request POST:/api/purchase/register-guardian
     */
    purchaseControllerRegisterGuardian: (data: RegisterGuardianBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/purchase/register-guardian`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerRegisterStudent
     * @request POST:/api/purchase/register-student
     */
    purchaseControllerRegisterStudent: (data: RegisterStudentBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/purchase/register-student`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerGetTransactionStatus
     * @request GET:/api/purchase/status/{sessionId}
     */
    purchaseControllerGetTransactionStatus: (sessionId: string, params: RequestParams = {}) =>
      this.request<GetTransactionStatusResponse, any>({
        path: `/api/purchase/status/${sessionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerGetUpsellPreview
     * @request GET:/api/purchase/upsell-preview
     */
    purchaseControllerGetUpsellPreview: (
      query?: {
        /** @format email */
        studentEmail?: string;
        /** @format uuid */
        schoolClassId?: string;
        /** @minLength 36 */
        subjectIds?: string;
        interval?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUpsellPreviewResponse, any>({
        path: `/api/purchase/upsell-preview`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerInitUpsell
     * @request POST:/api/purchase/upsell/init
     */
    purchaseControllerInitUpsell: (data: InitUpsellBody, params: RequestParams = {}) =>
      this.request<InitUpsellResponse, any>({
        path: `/api/purchase/upsell/init`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerGetSubscriptionPricing
     * @request GET:/api/purchase/subscription-pricing
     */
    purchaseControllerGetSubscriptionPricing: (
      query?: {
        /** @format uuid */
        schoolClassId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSubscriptionPricingResponse, any>({
        path: `/api/purchase/subscription-pricing`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerQuoteSubscription
     * @request POST:/api/purchase/quote
     */
    purchaseControllerQuoteSubscription: (
      data: QuoteSubscriptionBody,
      params: RequestParams = {},
    ) =>
      this.request<QuoteSubscriptionResponse, any>({
        path: `/api/purchase/quote`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerGetStudentSubjects
     * @request GET:/api/purchase/student-subjects
     */
    purchaseControllerGetStudentSubjects: (
      query?: {
        /** @format email */
        studentEmail?: string;
        /** @format uuid */
        schoolClassId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStudentSubjectsResponse, any>({
        path: `/api/purchase/student-subjects`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PurchaseControllerGetSavedCards
     * @request GET:/api/purchase/saved-cards
     */
    purchaseControllerGetSavedCards: (params: RequestParams = {}) =>
      this.request<GetSavedCardsResponse, any>({
        path: `/api/purchase/saved-cards`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DiscountCodesControllerGetDiscountCodes
     * @request GET:/api/discount-codes
     */
    discountCodesControllerGetDiscountCodes: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDiscountCodesResponse, any>({
        path: `/api/discount-codes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DiscountCodesControllerCreateDiscountCode
     * @request POST:/api/discount-codes
     */
    discountCodesControllerCreateDiscountCode: (
      data: CreateDiscountCodeBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateDiscountCodeResponse, any>({
        path: `/api/discount-codes`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminDiscountCodesControllerGetAllDiscountCodes
     * @request GET:/api/admin/discount-codes
     */
    adminDiscountCodesControllerGetAllDiscountCodes: (
      query?: {
        isActive?: "true" | "false";
        codeType?: "SINGLE_USE" | "MULTI_USE";
        /** @format uuid */
        schoolClassId?: string;
        name?: string;
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllDiscountCodesResponse, any>({
        path: `/api/admin/discount-codes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminDiscountCodesControllerCreateAdminDiscountCodes
     * @request POST:/api/admin/discount-codes
     */
    adminDiscountCodesControllerCreateAdminDiscountCodes: (
      data: CreateAdminDiscountCodesBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateAdminDiscountCodesResponse, any>({
        path: `/api/admin/discount-codes`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminDiscountCodesControllerGetDiscountCodeDetails
     * @request GET:/api/admin/discount-codes/{id}
     */
    adminDiscountCodesControllerGetDiscountCodeDetails: (id: string, params: RequestParams = {}) =>
      this.request<GetDiscountCodeDetailsResponse, any>({
        path: `/api/admin/discount-codes/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminDiscountCodesControllerArchiveDiscountCode
     * @request PATCH:/api/admin/discount-codes/{id}/archive
     */
    adminDiscountCodesControllerArchiveDiscountCode: (
      id: string,
      data: ArchiveDiscountCodeBody,
      params: RequestParams = {},
    ) =>
      this.request<ArchiveDiscountCodeResponse, any>({
        path: `/api/admin/discount-codes/${id}/archive`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminDiscountCodesControllerGetDiscountCodeUsageHistory
     * @request GET:/api/admin/discount-codes/{id}/usage-history
     */
    adminDiscountCodesControllerGetDiscountCodeUsageHistory: (
      id: string,
      query?: {
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDiscountCodeUsageHistoryResponse, any>({
        path: `/api/admin/discount-codes/${id}/usage-history`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminDiscountCodesControllerGetUserDiscountCodesUsage
     * @request GET:/api/admin/discount-codes/user/{userEmail}/usage
     */
    adminDiscountCodesControllerGetUserDiscountCodesUsage: (
      userEmail: string,
      params: RequestParams = {},
    ) =>
      this.request<GetUserDiscountCodesUsageResponse, any>({
        path: `/api/admin/discount-codes/user/${userEmail}/usage`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminDiscountCodesControllerApplyDiscountCode
     * @request POST:/api/admin/discount-codes/apply
     */
    adminDiscountCodesControllerApplyDiscountCode: (
      data: ApplyDiscountCodeBody,
      params: RequestParams = {},
    ) =>
      this.request<ApplyDiscountCodeResponse, any>({
        path: `/api/admin/discount-codes/apply`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AbandonedCartControllerTrack
     * @request POST:/api/abandoned-cart/track
     */
    abandonedCartControllerTrack: (data: TrackBody, params: RequestParams = {}) =>
      this.request<TrackResponse, any>({
        path: `/api/abandoned-cart/track`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GuardianControllerGetGuardianStudents
     * @request GET:/api/guardian/assigned-students
     */
    guardianControllerGetGuardianStudents: (params: RequestParams = {}) =>
      this.request<GetGuardianStudentsResponse, any>({
        path: `/api/guardian/assigned-students`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GuardianControllerAddGuardian
     * @request POST:/api/guardian/add-guardian
     */
    guardianControllerAddGuardian: (data: AddGuardianBody, params: RequestParams = {}) =>
      this.request<AddGuardianResponse, any>({
        path: `/api/guardian/add-guardian`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GuardianControllerLinkStudent
     * @request POST:/api/guardian/link-student
     */
    guardianControllerLinkStudent: (data: LinkStudentBody, params: RequestParams = {}) =>
      this.request<LinkStudentResponse, any>({
        path: `/api/guardian/link-student`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GuardianControllerValidateStudentGuardianRelationship
     * @request POST:/api/guardian/validate-student-guardian
     */
    guardianControllerValidateStudentGuardianRelationship: (
      data: ValidateStudentGuardianRelationshipBody,
      params: RequestParams = {},
    ) =>
      this.request<ValidateStudentGuardianRelationshipResponse, any>({
        path: `/api/guardian/validate-student-guardian`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name HealthControllerCheck
     * @request GET:/api/healthcheck
     */
    healthControllerCheck: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "ok" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        },
        {
          /** @example "error" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"redis":{"status":"down","message":"Could not connect"}} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        }
      >({
        path: `/api/healthcheck`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TestConfigControllerSetup
     * @request POST:/api/test-config/setup
     */
    testConfigControllerSetup: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/test-config/setup`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name TestConfigControllerTeardown
     * @request POST:/api/test-config/teardown
     */
    testConfigControllerTeardown: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/test-config/teardown`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectControllerGetAllSubjects
     * @request GET:/api/subject
     */
    subjectControllerGetAllSubjects: (
      query?: {
        title?: string;
        archived?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: "title" | "creationDate" | "-title" | "-creationDate";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllSubjectsResponse, any>({
        path: `/api/subject`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectControllerCreateSubject
     * @request POST:/api/subject
     */
    subjectControllerCreateSubject: (data: CreateSubjectBody, params: RequestParams = {}) =>
      this.request<CreateSubjectResponse, any>({
        path: `/api/subject`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectControllerGetSubjectById
     * @request GET:/api/subject/{id}
     */
    subjectControllerGetSubjectById: (id: string, params: RequestParams = {}) =>
      this.request<GetSubjectByIdResponse, any>({
        path: `/api/subject/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectControllerUpdateSubject
     * @request PATCH:/api/subject/{id}
     */
    subjectControllerUpdateSubject: (
      id: string,
      data: UpdateSubjectBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubjectResponse, any>({
        path: `/api/subject/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectControllerGetSubjectsByIds
     * @request POST:/api/subject/by-ids
     */
    subjectControllerGetSubjectsByIds: (data: GetSubjectsByIdsBody, params: RequestParams = {}) =>
      this.request<GetSubjectsByIdsResponse, any>({
        path: `/api/subject/by-ids`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetAllCourses
     * @request GET:/api/course/all
     */
    courseControllerGetAllCourses: (
      query?: {
        title?: string;
        /** @format uuid */
        subjectId?: string;
        /** @format uuid */
        authorId?: string;
        "creationDateRange[0]"?: string;
        "creationDateRange[1]"?: string;
        sort?:
          | "title"
          | "subject"
          | "creationDate"
          | "author"
          | "chapterCount"
          | "enrolledParticipantsCount"
          | "-title"
          | "-subject"
          | "-creationDate"
          | "-author"
          | "-chapterCount"
          | "-enrolledParticipantsCount";
        /** @min 1 */
        page?: number;
        perPage?: number;
        /** @format uuid */
        schoolClassId?: string;
        /** @format uuid */
        teacherId?: string;
        isPublished?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllCoursesResponse, any>({
        path: `/api/course/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetStudentCourses
     * @request GET:/api/course/get-student-courses
     */
    courseControllerGetStudentCourses: (
      query?: {
        /** @format uuid */
        subjectId?: string;
        /** @format uuid */
        schoolClassId?: string;
        progressStatus?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?:
          | "title"
          | "subject"
          | "creationDate"
          | "author"
          | "chapterCount"
          | "enrolledParticipantsCount"
          | "-title"
          | "-subject"
          | "-creationDate"
          | "-author"
          | "-chapterCount"
          | "-enrolledParticipantsCount";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStudentCoursesResponse, any>({
        path: `/api/course/get-student-courses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetSubjectCourses
     * @request GET:/api/course/subject-courses
     */
    courseControllerGetSubjectCourses: (
      query: {
        subjectId: string;
        schoolClassId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSubjectCoursesResponse, any>({
        path: `/api/course/subject-courses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetStudentClassSelection
     * @request GET:/api/course/student-class-selection
     */
    courseControllerGetStudentClassSelection: (
      query?: {
        /** @format uuid */
        subjectId?: string;
        /** @format uuid */
        schoolClassId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStudentClassSelectionResponse, any>({
        path: `/api/course/student-class-selection`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetTrialStudentClassSelection
     * @request GET:/api/course/trial-student-class-selection
     */
    courseControllerGetTrialStudentClassSelection: (params: RequestParams = {}) =>
      this.request<GetTrialStudentClassSelectionResponse, any>({
        path: `/api/course/trial-student-class-selection`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourse
     * @request GET:/api/course
     */
    courseControllerGetCourse: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCourseResponse, any>({
        path: `/api/course`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerCreateCourse
     * @request POST:/api/course
     */
    courseControllerCreateCourse: (data: CreateCourseBody, params: RequestParams = {}) =>
      this.request<CreateCourseResponse, any>({
        path: `/api/course`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetBetaCourseById
     * @request GET:/api/course/beta-course-by-id
     */
    courseControllerGetBetaCourseById: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetBetaCourseByIdResponse, any>({
        path: `/api/course/beta-course-by-id`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetDisplayOrderBySubjectAndSchoolClass
     * @request GET:/api/course/display-order-by-subject-and-school-class
     */
    courseControllerGetDisplayOrderBySubjectAndSchoolClass: (
      query: {
        /** @format uuid */
        subjectId: string;
        /** @format uuid */
        schoolClassId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDisplayOrderBySubjectAndSchoolClassResponse, any>({
        path: `/api/course/display-order-by-subject-and-school-class`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerDuplicateCourse
     * @request POST:/api/course/{id}/duplicate
     */
    courseControllerDuplicateCourse: (
      id: string,
      data: DuplicateCourseBody,
      params: RequestParams = {},
    ) =>
      this.request<DuplicateCourseResponse, any>({
        path: `/api/course/${id}/duplicate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUpdateCourse
     * @request PATCH:/api/course/{id}
     */
    courseControllerUpdateCourse: (
      id: string,
      data: UpdateCourseBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCourseResponse, any>({
        path: `/api/course/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerEnrollCourse
     * @request POST:/api/course/enroll-course
     */
    courseControllerEnrollCourse: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EnrollCourseResponse, any>({
        path: `/api/course/enroll-course`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUnpublishCourse
     * @request PATCH:/api/course/unpublish/{id}
     */
    courseControllerUnpublishCourse: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/course/unpublish/${id}`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUnenrollCourse
     * @request DELETE:/api/course/unenroll-course
     */
    courseControllerUnenrollCourse: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UnenrollCourseResponse, any>({
        path: `/api/course/unenroll-course`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerDeleteCourse
     * @request DELETE:/api/course/remove
     */
    courseControllerDeleteCourse: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteCourseResponse, any>({
        path: `/api/course/remove`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerDeleteManyCourses
     * @request DELETE:/api/course/remove-many-courses
     */
    courseControllerDeleteManyCourses: (
      query?: {
        ids?: string | string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteManyCoursesResponse, any>({
        path: `/api/course/remove-many-courses`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetExams
     * @request GET:/api/lesson/exams
     */
    lessonControllerGetExams: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetExamsResponse, any>({
        path: `/api/lesson/exams`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetStudentExams
     * @request GET:/api/lesson/exams/student
     */
    lessonControllerGetStudentExams: (
      query?: {
        schoolClasses?: string[];
        subjects?: string[];
        testTypes?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStudentExamsResponse, any>({
        path: `/api/lesson/exams/student`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetLessonsWithFilters
     * @request GET:/api/lesson/lessons-with-filters
     */
    lessonControllerGetLessonsWithFilters: (
      query: {
        /** @format uuid */
        subjectId: string;
        /** @format uuid */
        schoolClassId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetLessonsWithFiltersResponse, any>({
        path: `/api/lesson/lessons-with-filters`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetMissingVimeoThumbnails
     * @request GET:/api/lesson/missing-vimeo-thumbnails
     */
    lessonControllerGetMissingVimeoThumbnails: (params: RequestParams = {}) =>
      this.request<GetMissingVimeoThumbnailsResponse, any>({
        path: `/api/lesson/missing-vimeo-thumbnails`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetLessonById
     * @request GET:/api/lesson/{id}
     */
    lessonControllerGetLessonById: (id: string, params: RequestParams = {}) =>
      this.request<GetLessonByIdResponse, any>({
        path: `/api/lesson/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetExamById
     * @request GET:/api/lesson/exam/{id}
     */
    lessonControllerGetExamById: (id: string, params: RequestParams = {}) =>
      this.request<GetExamByIdResponse, any>({
        path: `/api/lesson/exam/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerFinalizeExamIfExpired
     * @request POST:/api/lesson/exam/{id}/finalize-if-expired
     */
    lessonControllerFinalizeExamIfExpired: (id: string, params: RequestParams = {}) =>
      this.request<FinalizeExamIfExpiredResponse, any>({
        path: `/api/lesson/exam/${id}/finalize-if-expired`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerSaveExamDraftAnswer
     * @request POST:/api/lesson/exam/{id}/draft-answer
     */
    lessonControllerSaveExamDraftAnswer: (
      id: string,
      data: SaveExamDraftAnswerBody,
      params: RequestParams = {},
    ) =>
      this.request<SaveExamDraftAnswerResponse, any>({
        path: `/api/lesson/exam/${id}/draft-answer`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaCreateLesson
     * @request POST:/api/lesson/beta-create-lesson
     */
    lessonControllerBetaCreateLesson: (data: BetaCreateLessonBody, params: RequestParams = {}) =>
      this.request<BetaCreateLessonResponse, any>({
        path: `/api/lesson/beta-create-lesson`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaCreateQuizLesson
     * @request POST:/api/lesson/beta-create-lesson/quiz
     */
    lessonControllerBetaCreateQuizLesson: (
      data: BetaCreateQuizLessonBody,
      params: RequestParams = {},
    ) =>
      this.request<BetaCreateQuizLessonResponse, any>({
        path: `/api/lesson/beta-create-lesson/quiz`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaUpdateQuizLesson
     * @request PATCH:/api/lesson/beta-update-lesson/quiz
     */
    lessonControllerBetaUpdateQuizLesson: (
      data: BetaUpdateQuizLessonBody,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BetaUpdateQuizLessonResponse, any>({
        path: `/api/lesson/beta-update-lesson/quiz`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaUpdateLesson
     * @request PATCH:/api/lesson/beta-update-lesson
     */
    lessonControllerBetaUpdateLesson: (
      data: BetaUpdateLessonBody,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BetaUpdateLessonResponse, any>({
        path: `/api/lesson/beta-update-lesson`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerRemoveLesson
     * @request DELETE:/api/lesson
     */
    lessonControllerRemoveLesson: (
      query: {
        /** @format uuid */
        lessonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RemoveLessonResponse, any>({
        path: `/api/lesson`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerTrialQuizAnswers
     * @request POST:/api/lesson/trial-quiz-answers
     */
    lessonControllerTrialQuizAnswers: (data: TrialQuizAnswersBody, params: RequestParams = {}) =>
      this.request<TrialQuizAnswersResponse, any>({
        path: `/api/lesson/trial-quiz-answers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerPreviewQuizAnswers
     * @request POST:/api/lesson/preview-quiz-answers
     */
    lessonControllerPreviewQuizAnswers: (
      data: PreviewQuizAnswersBody,
      params: RequestParams = {},
    ) =>
      this.request<PreviewQuizAnswersResponse, any>({
        path: `/api/lesson/preview-quiz-answers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerEvaluationQuiz
     * @request POST:/api/lesson/evaluation-quiz
     */
    lessonControllerEvaluationQuiz: (data: EvaluationQuizBody, params: RequestParams = {}) =>
      this.request<EvaluationQuizResponse, any>({
        path: `/api/lesson/evaluation-quiz`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerClearQuizProgress
     * @request DELETE:/api/lesson/clear-quiz-progress
     */
    lessonControllerClearQuizProgress: (data: ClearQuizProgressBody, params: RequestParams = {}) =>
      this.request<ClearQuizProgressResponse, any>({
        path: `/api/lesson/clear-quiz-progress`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerUpdateLessonDisplayOrder
     * @request PATCH:/api/lesson/update-lesson-display-order
     */
    lessonControllerUpdateLessonDisplayOrder: (
      data: UpdateLessonDisplayOrderBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateLessonDisplayOrderResponse, any>({
        path: `/api/lesson/update-lesson-display-order`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerDownloadAdditionalResource
     * @request POST:/api/lesson/resource/{id}/download
     */
    lessonControllerDownloadAdditionalResource: (id: string, params: RequestParams = {}) =>
      this.request<DownloadAdditionalResourceResponse, any>({
        path: `/api/lesson/resource/${id}/download`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerWatchVideoEvent
     * @request POST:/api/lesson/watch-video/{id}
     */
    lessonControllerWatchVideoEvent: (id: string, params: RequestParams = {}) =>
      this.request<WatchVideoEventResponse, any>({
        path: `/api/lesson/watch-video/${id}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerWatchVideo70PercentEvent
     * @request POST:/api/lesson/watch-video-70-percent/{id}
     */
    lessonControllerWatchVideo70PercentEvent: (id: string, params: RequestParams = {}) =>
      this.request<WatchVideo70PercentEventResponse, any>({
        path: `/api/lesson/watch-video-70-percent/${id}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerUpdateLessonVimeoThumbnail
     * @request PATCH:/api/lesson/vimeo-thumbnail-update
     */
    lessonControllerUpdateLessonVimeoThumbnail: (
      query: {
        vimeoThumbnailS3Key: string;
        /** @format uuid */
        lessonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateLessonVimeoThumbnailResponse, any>({
        path: `/api/lesson/vimeo-thumbnail-update`,
        method: "PATCH",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerCreateExam
     * @request POST:/api/lesson/create-exam
     */
    lessonControllerCreateExam: (data: CreateExamBody, params: RequestParams = {}) =>
      this.request<CreateExamResponse, any>({
        path: `/api/lesson/create-exam`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerUpdateExam
     * @request PATCH:/api/lesson/update-exam/{id}
     */
    lessonControllerUpdateExam: (id: string, data: UpdateExamBody, params: RequestParams = {}) =>
      this.request<UpdateExamResponse, any>({
        path: `/api/lesson/update-exam/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerDuplicateLesson
     * @request POST:/api/lesson/{id}/duplicate
     */
    lessonControllerDuplicateLesson: (
      id: string,
      data: DuplicateLessonBody,
      params: RequestParams = {},
    ) =>
      this.request<DuplicateLessonResponse, any>({
        path: `/api/lesson/${id}/duplicate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminAiGradingControllerListLessons
     * @request GET:/api/admin/ai-grading/lessons
     */
    adminAiGradingControllerListLessons: (
      query?: {
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
        search?: string;
        /** @format uuid */
        subjectId?: string;
        /** @format uuid */
        schoolClassId?: string;
        /** @format uuid */
        chapterId?: string;
        /** @format uuid */
        authorId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListLessonsResponse, any>({
        path: `/api/admin/ai-grading/lessons`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminAiGradingControllerListAttempts
     * @request GET:/api/admin/ai-grading/lessons/{lessonId}/attempts
     */
    adminAiGradingControllerListAttempts: (
      lessonId: string,
      query?: {
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListAttemptsResponse, any>({
        path: `/api/admin/ai-grading/lessons/${lessonId}/attempts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminAiGradingControllerGetAttemptReview
     * @request GET:/api/admin/ai-grading/lessons/{lessonId}/attempts/{userId}
     */
    adminAiGradingControllerGetAttemptReview: (
      lessonId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetAttemptReviewResponse, any>({
        path: `/api/admin/ai-grading/lessons/${lessonId}/attempts/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AiQuizControllerGenerateQuiz
     * @request POST:/api/ai/quiz/generate
     */
    aiQuizControllerGenerateQuiz: (data: GenerateQuizBody, params: RequestParams = {}) =>
      this.request<GenerateQuizResponse, any>({
        path: `/api/ai/quiz/generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AiQuizControllerCancelJob
     * @request POST:/api/ai/quiz/job/{id}/cancel
     */
    aiQuizControllerCancelJob: (id: string, params: RequestParams = {}) =>
      this.request<CancelJobResponse, any>({
        path: `/api/ai/quiz/job/${id}/cancel`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AiQuizControllerGetJob
     * @request GET:/api/ai/quiz/job/{id}
     */
    aiQuizControllerGetJob: (id: string, params: RequestParams = {}) =>
      this.request<GetJobResponse, any>({
        path: `/api/ai/quiz/job/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PromptControllerList
     * @request GET:/api/prompt
     */
    promptControllerList: (params: RequestParams = {}) =>
      this.request<ListResponse, any>({
        path: `/api/prompt`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PromptControllerUpdate
     * @request POST:/api/prompt/update
     */
    promptControllerUpdate: (data: UpdateBody, params: RequestParams = {}) =>
      this.request<UpdateResponse, any>({
        path: `/api/prompt/update`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PromptControllerReset
     * @request POST:/api/prompt/reset
     */
    promptControllerReset: (data: ResetBody, params: RequestParams = {}) =>
      this.request<ResetResponse, any>({
        path: `/api/prompt/reset`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerCreateIndex
     * @request POST:/api/opensearch/create-index
     */
    opensearchControllerCreateIndex: (
      query: {
        index: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/create-index`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerCreateCustomIndex
     * @request POST:/api/opensearch/create-custom-index
     */
    opensearchControllerCreateCustomIndex: (
      query: {
        index: string;
      },
      data: Body,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/create-custom-index`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerImportLessonsToDocuments
     * @request POST:/api/opensearch/import-lessons-to-documents
     */
    opensearchControllerImportLessonsToDocuments: (
      query: {
        index: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/import-lessons-to-documents`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerSearch
     * @request GET:/api/opensearch/search
     */
    opensearchControllerSearch: (
      query: {
        index: string;
        phrase: string;
        schoolClasses?: string[];
        subjects?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResponse, any>({
        path: `/api/opensearch/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerSearchPaginated
     * @request GET:/api/opensearch/search-paginated
     */
    opensearchControllerSearchPaginated: (
      query: {
        index: string;
        page: number;
        pageSize: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/search-paginated`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerSearchHistory
     * @request GET:/api/opensearch/search-history
     */
    opensearchControllerSearchHistory: (params: RequestParams = {}) =>
      this.request<SearchHistoryResponse, any>({
        path: `/api/opensearch/search-history`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerAddSearchHistory
     * @request POST:/api/opensearch/add-search-history
     */
    opensearchControllerAddSearchHistory: (
      query: {
        phrase: string;
        /** @format uuid */
        lessonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/add-search-history`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerDeleteIndex
     * @request DELETE:/api/opensearch/delete-index
     */
    opensearchControllerDeleteIndex: (
      query: {
        index: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/delete-index`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name OpensearchControllerAutoReloadIndex
     * @request POST:/api/opensearch/auto-reload-index
     */
    opensearchControllerAutoReloadIndex: (
      query: {
        index: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/opensearch/auto-reload-index`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentPreferencesControllerGetStudentPreferences
     * @request GET:/api/student-preferences
     */
    studentPreferencesControllerGetStudentPreferences: (params: RequestParams = {}) =>
      this.request<GetStudentPreferencesResponse, any>({
        path: `/api/student-preferences`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentPreferencesControllerCreateStudentPreferences
     * @request POST:/api/student-preferences
     */
    studentPreferencesControllerCreateStudentPreferences: (
      data: CreateStudentPreferencesBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateStudentPreferencesResponse, any>({
        path: `/api/student-preferences`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SchoolClassControllerGetAllSchoolClasses
     * @request GET:/api/school-class
     */
    schoolClassControllerGetAllSchoolClasses: (params: RequestParams = {}) =>
      this.request<GetAllSchoolClassesResponse, any>({
        path: `/api/school-class`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SchoolClassControllerGetSchoolClassById
     * @request GET:/api/school-class/{id}
     */
    schoolClassControllerGetSchoolClassById: (id: string, params: RequestParams = {}) =>
      this.request<GetSchoolClassByIdResponse, any>({
        path: `/api/school-class/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerGetAllTeachers
     * @request GET:/api/teachers/all
     */
    teachersControllerGetAllTeachers: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllTeachersResponse, any>({
        path: `/api/teachers/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerGetTeacherById
     * @request GET:/api/teachers/{id}
     */
    teachersControllerGetTeacherById: (id: string, params: RequestParams = {}) =>
      this.request<GetTeacherByIdResponse, any>({
        path: `/api/teachers/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerUpdateTeacher
     * @request PATCH:/api/teachers/{id}
     */
    teachersControllerUpdateTeacher: (
      id: string,
      data: UpdateTeacherBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTeacherResponse, any>({
        path: `/api/teachers/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerDeleteTeacher
     * @request DELETE:/api/teachers/{id}
     */
    teachersControllerDeleteTeacher: (id: string, params: RequestParams = {}) =>
      this.request<DeleteTeacherResponse, any>({
        path: `/api/teachers/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TeachersControllerCreateTeacher
     * @request POST:/api/teachers
     */
    teachersControllerCreateTeacher: (data: CreateTeacherBody, params: RequestParams = {}) =>
      this.request<CreateTeacherResponse, any>({
        path: `/api/teachers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionPlanControllerGetAllSubscriptionPlans
     * @request GET:/api/subscriptionPlan
     */
    subscriptionPlanControllerGetAllSubscriptionPlans: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: "name" | "schoolClass" | "creationDate" | "-name" | "-schoolClass" | "-creationDate";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllSubscriptionPlansResponse, any>({
        path: `/api/subscriptionPlan`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionPlanControllerGetSubscriptionPlanById
     * @request GET:/api/subscriptionPlan/{id}
     */
    subscriptionPlanControllerGetSubscriptionPlanById: (id: string, params: RequestParams = {}) =>
      this.request<GetSubscriptionPlanByIdResponse, any>({
        path: `/api/subscriptionPlan/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionPlanControllerUpdateSubscriptionPlan
     * @request PATCH:/api/subscriptionPlan/{id}
     */
    subscriptionPlanControllerUpdateSubscriptionPlan: (
      id: string,
      data: UpdateSubscriptionPlanBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubscriptionPlanResponse, any>({
        path: `/api/subscriptionPlan/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerGetSubscriptionsByStudentId
     * @request GET:/api/subscription/student/{studentId}
     */
    subscriptionControllerGetSubscriptionsByStudentId: (
      studentId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetSubscriptionsByStudentIdResponse, any>({
        path: `/api/subscription/student/${studentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerGetGuardianChildrenSubscriptions
     * @request GET:/api/subscription/guardian/children
     */
    subscriptionControllerGetGuardianChildrenSubscriptions: (params: RequestParams = {}) =>
      this.request<GetGuardianChildrenSubscriptionsResponse, any>({
        path: `/api/subscription/guardian/children`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerGetActivationInfo
     * @request GET:/api/subscription/activate
     */
    subscriptionControllerGetActivationInfo: (
      query?: {
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetActivationInfoResponse, any>({
        path: `/api/subscription/activate`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerActivateSubscription
     * @request POST:/api/subscription/activate
     */
    subscriptionControllerActivateSubscription: (
      data: ActivateSubscriptionBody,
      params: RequestParams = {},
    ) =>
      this.request<ActivateSubscriptionResponse, any>({
        path: `/api/subscription/activate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerCheckAutoRenewals
     * @request POST:/api/subscription/check-auto-renewals
     */
    subscriptionControllerCheckAutoRenewals: (params: RequestParams = {}) =>
      this.request<CheckAutoRenewalsResponse, any>({
        path: `/api/subscription/check-auto-renewals`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerAdminListSubscriptions
     * @request GET:/api/subscription/admin/list
     */
    subscriptionControllerAdminListSubscriptions: (
      query?: {
        /** @min 1 */
        page?: number;
        /** @min 1 */
        perPage?: number;
        interval?: string;
        status?: string;
        /** @format uuid */
        schoolClassId?: string;
        keyword?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminListSubscriptionsResponse, any>({
        path: `/api/subscription/admin/list`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerAdminWeeklyConversion
     * @request GET:/api/subscription/admin/weekly-conversion
     */
    subscriptionControllerAdminWeeklyConversion: (
      query?: {
        from?: string;
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminWeeklyConversionResponse, any>({
        path: `/api/subscription/admin/weekly-conversion`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerAdminSubscriptionHistory
     * @request GET:/api/subscription/admin/{subscriptionId}/history
     */
    subscriptionControllerAdminSubscriptionHistory: (
      subscriptionId: string,
      params: RequestParams = {},
    ) =>
      this.request<AdminSubscriptionHistoryResponse, any>({
        path: `/api/subscription/admin/${subscriptionId}/history`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerRestoreSubscription
     * @request POST:/api/subscription/restore
     */
    subscriptionControllerRestoreSubscription: (
      data: RestoreSubscriptionBody,
      params: RequestParams = {},
    ) =>
      this.request<RestoreSubscriptionResponse, any>({
        path: `/api/subscription/restore`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerUpdateSubscriptionPaymentMethod
     * @request PATCH:/api/subscription/{subscriptionId}/payment-method
     */
    subscriptionControllerUpdateSubscriptionPaymentMethod: (
      subscriptionId: string,
      data: UpdateSubscriptionPaymentMethodBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubscriptionPaymentMethodResponse, any>({
        path: `/api/subscription/${subscriptionId}/payment-method`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerSwitchToMonthly
     * @request POST:/api/subscription/{subscriptionId}/switch-to-monthly
     */
    subscriptionControllerSwitchToMonthly: (subscriptionId: string, params: RequestParams = {}) =>
      this.request<SwitchToMonthlyResponse, any>({
        path: `/api/subscription/${subscriptionId}/switch-to-monthly`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerIntervalSwitchPreview
     * @request GET:/api/subscription/{subscriptionId}/interval-switch-preview
     */
    subscriptionControllerIntervalSwitchPreview: (
      subscriptionId: string,
      params: RequestParams = {},
    ) =>
      this.request<IntervalSwitchPreviewResponse, any>({
        path: `/api/subscription/${subscriptionId}/interval-switch-preview`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerIntervalSwitch
     * @request POST:/api/subscription/{subscriptionId}/interval-switch
     */
    subscriptionControllerIntervalSwitch: (
      subscriptionId: string,
      data: IntervalSwitchBody,
      params: RequestParams = {},
    ) =>
      this.request<IntervalSwitchResponse, any>({
        path: `/api/subscription/${subscriptionId}/interval-switch`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubscriptionControllerSendReactivationRequest
     * @request POST:/api/subscription/reactivation-request
     */
    subscriptionControllerSendReactivationRequest: (
      data: SendReactivationRequestBody,
      params: RequestParams = {},
    ) =>
      this.request<SendReactivationRequestResponse, any>({
        path: `/api/subscription/reactivation-request`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name P24ControllerHandleBlikAliasWebhook
     * @request POST:/api/p24/blik-alias-webhook
     */
    p24ControllerHandleBlikAliasWebhook: (
      data: HandleBlikAliasWebhookBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/p24/blik-alias-webhook`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name P24ControllerTestP24Connection
     * @request GET:/api/p24/test-connection
     */
    p24ControllerTestP24Connection: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/p24/test-connection`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name P24ControllerGetPaymentsHistoryByGuardianId
     * @request GET:/api/p24/payments-history
     */
    p24ControllerGetPaymentsHistoryByGuardianId: (
      query?: {
        studentIds?: string[];
        page?: number;
        perPage?: number;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPaymentsHistoryByGuardianIdResponse, any>({
        path: `/api/p24/payments-history`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name P24ControllerCancelSubscription
     * @request POST:/api/p24/cancel-subscription
     */
    p24ControllerCancelSubscription: (data: CancelSubscriptionBody, params: RequestParams = {}) =>
      this.request<CancelSubscriptionResponse, any>({
        path: `/api/p24/cancel-subscription`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name P24ControllerGetTransactionBySessionId
     * @request GET:/api/p24/transaction/{sessionId}
     */
    p24ControllerGetTransactionBySessionId: (sessionId: string, params: RequestParams = {}) =>
      this.request<GetTransactionBySessionIdResponse, any>({
        path: `/api/p24/transaction/${sessionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EmailEventsDevControllerTrigger
     * @request POST:/api/email-events/dev/trigger
     */
    emailEventsDevControllerTrigger: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/email-events/dev/trigger`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name GamificationControllerGetGamificationBadges
     * @request GET:/api/gamification/gamification-badges
     */
    gamificationControllerGetGamificationBadges: (
      query?: {
        types?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGamificationBadgesResponse, any>({
        path: `/api/gamification/gamification-badges`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GamificationControllerGetGamificationBadgeById
     * @request GET:/api/gamification/gamification-badge/{id}
     */
    gamificationControllerGetGamificationBadgeById: (id: string, params: RequestParams = {}) =>
      this.request<GetGamificationBadgeByIdResponse, any>({
        path: `/api/gamification/gamification-badge/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GamificationControllerUpdateGamificationBadge
     * @request PATCH:/api/gamification/gamification-badge/{id}
     */
    gamificationControllerUpdateGamificationBadge: (
      id: string,
      data: UpdateGamificationBadgeBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateGamificationBadgeResponse, any>({
        path: `/api/gamification/gamification-badge/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GamificationControllerGetUserAchievements
     * @request GET:/api/gamification/user-achievements
     */
    gamificationControllerGetUserAchievements: (
      query?: {
        badgeType?: "POWER_SIGN" | "!POWER_SIGN";
        isAchieved?: "true" | "false";
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserAchievementsResponse, any>({
        path: `/api/gamification/user-achievements`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GamificationControllerGetSharedAchievement
     * @request GET:/api/gamification/shared-achievement/{userAchievementId}
     */
    gamificationControllerGetSharedAchievement: (
      userAchievementId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetSharedAchievementResponse, any>({
        path: `/api/gamification/shared-achievement/${userAchievementId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerHealthCheck
     * @request GET:/api/threads/health
     */
    chatBotControllerHealthCheck: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/threads/health`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerListMessages
     * @request GET:/api/threads/{threadId}/messages
     */
    chatBotControllerListMessages: (threadId: string, params: RequestParams = {}) =>
      this.request<ListMessagesResponse, any>({
        path: `/api/threads/${threadId}/messages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerCreateMessage
     * @request POST:/api/threads/{threadId}/messages
     */
    chatBotControllerCreateMessage: (
      threadId: string,
      data: CreateMessageBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateMessageResponse, any>({
        path: `/api/threads/${threadId}/messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerGetUserThreads
     * @request GET:/api/threads/user-threads
     */
    chatBotControllerGetUserThreads: (params: RequestParams = {}) =>
      this.request<GetUserThreadsResponse, any>({
        path: `/api/threads/user-threads`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerGetThreadByLesson
     * @request GET:/api/threads/lesson/{lessonId}/thread
     */
    chatBotControllerGetThreadByLesson: (lessonId: string, params: RequestParams = {}) =>
      this.request<GetThreadByLessonResponse, any>({
        path: `/api/threads/lesson/${lessonId}/thread`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerGetUserThreadId
     * @request GET:/api/threads/user-thread
     */
    chatBotControllerGetUserThreadId: (params: RequestParams = {}) =>
      this.request<GetUserThreadIdResponse, any>({
        path: `/api/threads/user-thread`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerGetTokenUsage
     * @request GET:/api/threads/lesson/{lessonId}/tokens
     */
    chatBotControllerGetTokenUsage: (lessonId: string, params: RequestParams = {}) =>
      this.request<GetTokenUsageResponse, any>({
        path: `/api/threads/lesson/${lessonId}/tokens`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerCreateThread
     * @request POST:/api/threads/lesson/{lessonId}
     */
    chatBotControllerCreateThread: (lessonId: string, params: RequestParams = {}) =>
      this.request<CreateThreadResponse, any>({
        path: `/api/threads/lesson/${lessonId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerCreateAnonymousMessage
     * @request POST:/api/threads/lesson/{lessonId}/anonymous
     */
    chatBotControllerCreateAnonymousMessage: (
      lessonId: string,
      data: Data,
      params: RequestParams = {},
    ) =>
      this.request<CreateAnonymousMessageResponse, any>({
        path: `/api/threads/lesson/${lessonId}/anonymous`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChatBotControllerDeleteLessonThreads
     * @request DELETE:/api/threads/{lessonId}/threads
     */
    chatBotControllerDeleteLessonThreads: (lessonId: string, params: RequestParams = {}) =>
      this.request<DeleteLessonThreadsResponse, any>({
        path: `/api/threads/${lessonId}/threads`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name BlikPurchaseControllerGetPricing
     * @request GET:/api/blik-purchase/pricing
     */
    blikPurchaseControllerGetPricing: (
      query: {
        schoolClassId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPricingResponse, any>({
        path: `/api/blik-purchase/pricing`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name BlikPurchaseControllerInitPurchase
     * @request POST:/api/blik-purchase/init
     */
    blikPurchaseControllerInitPurchase: (data: InitPurchaseBody, params: RequestParams = {}) =>
      this.request<InitPurchaseResponse, any>({
        path: `/api/blik-purchase/init`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name BlikPurchaseControllerHandleWebhook
     * @request POST:/api/blik-purchase/webhook
     */
    blikPurchaseControllerHandleWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/blik-purchase/webhook`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name BlikPurchaseControllerActivateAccess
     * @request POST:/api/blik-purchase/activate
     */
    blikPurchaseControllerActivateAccess: (data: ActivateAccessBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/blik-purchase/activate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name BlikPurchaseControllerRegisterBuyer
     * @request POST:/api/blik-purchase/register-buyer
     */
    blikPurchaseControllerRegisterBuyer: (data: RegisterBuyerBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/blik-purchase/register-buyer`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name BlikPurchaseControllerGetMyAccesses
     * @request GET:/api/blik-purchase/my-accesses
     */
    blikPurchaseControllerGetMyAccesses: (params: RequestParams = {}) =>
      this.request<GetMyAccessesResponse, any>({
        path: `/api/blik-purchase/my-accesses`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name BlikPurchaseControllerGetGuardianChildrenAccesses
     * @request GET:/api/blik-purchase/guardian/children-accesses
     */
    blikPurchaseControllerGetGuardianChildrenAccesses: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/blik-purchase/guardian/children-accesses`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name BlikPurchaseControllerGetBlikTransactionStatus
     * @request GET:/api/blik-purchase/transaction-status
     */
    blikPurchaseControllerGetBlikTransactionStatus: (
      query: {
        sessionId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetBlikTransactionStatusResponse, any>({
        path: `/api/blik-purchase/transaction-status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name BlikPurchaseControllerGetActiveAccessesByEmail
     * @request GET:/api/blik-purchase/active-accesses-by-email
     */
    blikPurchaseControllerGetActiveAccessesByEmail: (
      query: {
        studentEmail: string;
        schoolClassId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetActiveAccessesByEmailResponse, any>({
        path: `/api/blik-purchase/active-accesses-by-email`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FriendInvitationsControllerGetUserFriendsInvitations
     * @request GET:/api/friend-invitations
     */
    friendInvitationsControllerGetUserFriendsInvitations: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserFriendsInvitationsResponse, any>({
        path: `/api/friend-invitations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FriendInvitationsControllerCreateFriendInvitation
     * @request POST:/api/friend-invitations
     */
    friendInvitationsControllerCreateFriendInvitation: (
      data: CreateFriendInvitationBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateFriendInvitationResponse, any>({
        path: `/api/friend-invitations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EventHistoryControllerGetEventHistory
     * @request GET:/api/event-history
     */
    eventHistoryControllerGetEventHistory: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetEventHistoryResponse, any>({
        path: `/api/event-history`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerGetSystemMessages
     * @request GET:/api/system-messages
     */
    systemMessageControllerGetSystemMessages: (
      query?: {
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSystemMessagesResponse, any>({
        path: `/api/system-messages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerCreateSystemMessage
     * @request POST:/api/system-messages
     */
    systemMessageControllerCreateSystemMessage: (
      data: CreateSystemMessageBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateSystemMessageResponse, any>({
        path: `/api/system-messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerGetUserSystemMessages
     * @request GET:/api/system-messages/user-system-messages
     */
    systemMessageControllerGetUserSystemMessages: (params: RequestParams = {}) =>
      this.request<GetUserSystemMessagesResponse, any>({
        path: `/api/system-messages/user-system-messages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerMarkAllAsRead
     * @request PATCH:/api/system-messages/mark-all-as-read
     */
    systemMessageControllerMarkAllAsRead: (params: RequestParams = {}) =>
      this.request<MarkAllAsReadResponse, any>({
        path: `/api/system-messages/mark-all-as-read`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SystemMessageControllerHasUnreadSystemMessage
     * @request GET:/api/system-messages/has-unread
     */
    systemMessageControllerHasUnreadSystemMessage: (params: RequestParams = {}) =>
      this.request<HasUnreadSystemMessageResponse, any>({
        path: `/api/system-messages/has-unread`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetPublishedFlashcardCategories
     * @request GET:/api/flashcards/published-flashcard-categories
     */
    flashcardsControllerGetPublishedFlashcardCategories: (
      query?: {
        subjectIds?: string[];
        schoolClassIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPublishedFlashcardCategoriesResponse, any>({
        path: `/api/flashcards/published-flashcard-categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetPublishedFlashcardCategoryById
     * @request GET:/api/flashcards/published-flashcard-categories/{id}
     */
    flashcardsControllerGetPublishedFlashcardCategoryById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<GetPublishedFlashcardCategoryByIdResponse, any>({
        path: `/api/flashcards/published-flashcard-categories/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetAllFlashcardCategories
     * @request GET:/api/flashcards/flashcard-categories
     */
    flashcardsControllerGetAllFlashcardCategories: (
      query?: {
        title?: string;
        /** @format uuid */
        authorId?: string;
        /** @format uuid */
        subjectId?: string;
        /** @format uuid */
        schoolClassId?: string;
        isPublished?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllFlashcardCategoriesResponse, any>({
        path: `/api/flashcards/flashcard-categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerCreateFlashcardCategory
     * @request POST:/api/flashcards/flashcard-categories
     */
    flashcardsControllerCreateFlashcardCategory: (
      data: CreateFlashcardCategoryBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetUserFavoriteFlashcards
     * @request GET:/api/flashcards/student-favorite-flashcards
     */
    flashcardsControllerGetUserFavoriteFlashcards: (params: RequestParams = {}) =>
      this.request<GetUserFavoriteFlashcardsResponse, any>({
        path: `/api/flashcards/student-favorite-flashcards`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetFlashcardCategory
     * @request GET:/api/flashcards/flashcard-categories/{flashcardCategoryId}
     */
    flashcardsControllerGetFlashcardCategory: (
      flashcardCategoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories/${flashcardCategoryId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerDeleteFlashcardCategory
     * @request DELETE:/api/flashcards/flashcard-categories/{flashcardCategoryId}
     */
    flashcardsControllerDeleteFlashcardCategory: (
      flashcardCategoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeleteFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories/${flashcardCategoryId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetPublishedFlashcardsForCategoryStudent
     * @request GET:/api/flashcards/in-category/student
     */
    flashcardsControllerGetPublishedFlashcardsForCategoryStudent: (
      query?: {
        /** @format uuid */
        categoryId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPublishedFlashcardsForCategoryStudentResponse, any>({
        path: `/api/flashcards/in-category/student`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetFlashcardsForCategory
     * @request GET:/api/flashcards/in-category
     */
    flashcardsControllerGetFlashcardsForCategory: (
      query?: {
        /** @format uuid */
        categoryId?: string;
        title?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFlashcardsForCategoryResponse, any>({
        path: `/api/flashcards/in-category`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerGetFlashcard
     * @request GET:/api/flashcards/{id}
     */
    flashcardsControllerGetFlashcard: (id: string, params: RequestParams = {}) =>
      this.request<GetFlashcardResponse, any>({
        path: `/api/flashcards/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerUpdateFlashcard
     * @request PATCH:/api/flashcards/{id}
     */
    flashcardsControllerUpdateFlashcard: (
      id: string,
      data: UpdateFlashcardBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateFlashcardResponse, any>({
        path: `/api/flashcards/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerDeleteFlashcard
     * @request DELETE:/api/flashcards/{id}
     */
    flashcardsControllerDeleteFlashcard: (id: string, params: RequestParams = {}) =>
      this.request<DeleteFlashcardResponse, any>({
        path: `/api/flashcards/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerAddFavoriteFlashcard
     * @request POST:/api/flashcards/{id}/favorite
     */
    flashcardsControllerAddFavoriteFlashcard: (id: string, params: RequestParams = {}) =>
      this.request<AddFavoriteFlashcardResponse, any>({
        path: `/api/flashcards/${id}/favorite`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerRemoveFavoriteFlashcard
     * @request DELETE:/api/flashcards/{id}/favorite
     */
    flashcardsControllerRemoveFavoriteFlashcard: (id: string, params: RequestParams = {}) =>
      this.request<RemoveFavoriteFlashcardResponse, any>({
        path: `/api/flashcards/${id}/favorite`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerCompleteFlashcard
     * @request POST:/api/flashcards/progress/{flashcardCategoryId}/flashcard/{flashcardId}/complete
     */
    flashcardsControllerCompleteFlashcard: (
      flashcardCategoryId: string,
      flashcardId: string,
      params: RequestParams = {},
    ) =>
      this.request<CompleteFlashcardResponse, any>({
        path: `/api/flashcards/progress/${flashcardCategoryId}/flashcard/${flashcardId}/complete`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerCreateFlashcard
     * @request POST:/api/flashcards
     */
    flashcardsControllerCreateFlashcard: (data: CreateFlashcardBody, params: RequestParams = {}) =>
      this.request<CreateFlashcardResponse, any>({
        path: `/api/flashcards`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerUpdateFlashcardCategory
     * @request PATCH:/api/flashcards/flashcard-categories/edit/{flashcardCategoryId}
     */
    flashcardsControllerUpdateFlashcardCategory: (
      flashcardCategoryId: string,
      data: UpdateFlashcardCategoryBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories/edit/${flashcardCategoryId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerTogglePublishFlashcardCategory
     * @request PATCH:/api/flashcards/flashcard-categories/toggle-publish/{flashcardCategoryId}
     */
    flashcardsControllerTogglePublishFlashcardCategory: (
      flashcardCategoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<TogglePublishFlashcardCategoryResponse, any>({
        path: `/api/flashcards/flashcard-categories/toggle-publish/${flashcardCategoryId}`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FlashcardsControllerResetFlashcardProgress
     * @request DELETE:/api/flashcards/progress/{flashcardCategoryId}
     */
    flashcardsControllerResetFlashcardProgress: (
      flashcardCategoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<ResetFlashcardProgressResponse, any>({
        path: `/api/flashcards/progress/${flashcardCategoryId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ClassMigrationControllerGetCandidates
     * @request GET:/api/class-migration/candidates
     */
    classMigrationControllerGetCandidates: (params: RequestParams = {}) =>
      this.request<GetCandidatesResponse, any>({
        path: `/api/class-migration/candidates`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ClassMigrationControllerSend
     * @request POST:/api/class-migration/send
     */
    classMigrationControllerSend: (data: SendBody, params: RequestParams = {}) =>
      this.request<SendResponse, any>({
        path: `/api/class-migration/send`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ClassMigrationControllerConfirm
     * @request POST:/api/class-migration/confirm
     */
    classMigrationControllerConfirm: (data: ConfirmBody, params: RequestParams = {}) =>
      this.request<ConfirmResponse, any>({
        path: `/api/class-migration/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectDescriptionControllerGetAllSubjectDescriptions
     * @request GET:/api/admin/subject-descriptions
     */
    subjectDescriptionControllerGetAllSubjectDescriptions: (params: RequestParams = {}) =>
      this.request<GetAllSubjectDescriptionsResponse, any>({
        path: `/api/admin/subject-descriptions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectDescriptionControllerCreateSubjectDescription
     * @request POST:/api/admin/subject-descriptions
     */
    subjectDescriptionControllerCreateSubjectDescription: (
      data: CreateSubjectDescriptionBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateSubjectDescriptionResponse, any>({
        path: `/api/admin/subject-descriptions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectDescriptionControllerGetSubjectDescriptionById
     * @request GET:/api/admin/subject-descriptions/{id}
     */
    subjectDescriptionControllerGetSubjectDescriptionById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<GetSubjectDescriptionByIdResponse, any>({
        path: `/api/admin/subject-descriptions/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectDescriptionControllerUpdateSubjectDescription
     * @request PATCH:/api/admin/subject-descriptions/{id}
     */
    subjectDescriptionControllerUpdateSubjectDescription: (
      id: string,
      data: UpdateSubjectDescriptionBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubjectDescriptionResponse, any>({
        path: `/api/admin/subject-descriptions/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubjectDescriptionControllerDeleteSubjectDescription
     * @request DELETE:/api/admin/subject-descriptions/{id}
     */
    subjectDescriptionControllerDeleteSubjectDescription: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<DeleteSubjectDescriptionResponse, any>({
        path: `/api/admin/subject-descriptions/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FeatureFlagControllerGetFeatureFlags
     * @request GET:/api/feature-flags
     */
    featureFlagControllerGetFeatureFlags: (params: RequestParams = {}) =>
      this.request<GetFeatureFlagsResponse, any>({
        path: `/api/feature-flags`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetSubjects
     * @request GET:/api/tutoring/subjects
     */
    tutoringControllerGetSubjects: (params: RequestParams = {}) =>
      this.request<GetSubjectsResponse, any>({
        path: `/api/tutoring/subjects`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetTutors
     * @request GET:/api/tutoring/tutors
     */
    tutoringControllerGetTutors: (
      query?: {
        /** @format uuid */
        subjectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetTutorsResponse, any>({
        path: `/api/tutoring/tutors`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetAvailability
     * @request GET:/api/tutoring/availability
     */
    tutoringControllerGetAvailability: (
      query?: {
        /** @format uuid */
        subjectId?: string;
        start?: string;
        end?: string;
        timeZone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAvailabilityResponse, any>({
        path: `/api/tutoring/availability`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetTutorProfile
     * @request GET:/api/tutoring/tutors/{id}
     */
    tutoringControllerGetTutorProfile: (id: string, params: RequestParams = {}) =>
      this.request<GetTutorProfileResponse, any>({
        path: `/api/tutoring/tutors/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetTutorSubject
     * @request GET:/api/tutoring/tutor-subjects/{id}
     */
    tutoringControllerGetTutorSubject: (id: string, params: RequestParams = {}) =>
      this.request<GetTutorSubjectResponse, any>({
        path: `/api/tutoring/tutor-subjects/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerRegisterTransaction
     * @request POST:/api/tutoring/purchase/register-transaction
     */
    tutoringControllerRegisterTransaction: (
      data: RegisterTransactionBody,
      params: RequestParams = {},
    ) =>
      this.request<RegisterTransactionResponse, any>({
        path: `/api/tutoring/purchase/register-transaction`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerUpdateTopic
     * @request PATCH:/api/tutoring/bookings/{id}/topic
     */
    tutoringControllerUpdateTopic: (
      id: string,
      data: UpdateTopicBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTopicResponse, any>({
        path: `/api/tutoring/bookings/${id}/topic`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetMyBookings
     * @request GET:/api/tutoring/bookings/mine
     */
    tutoringControllerGetMyBookings: (
      query?: {
        /** @format uuid */
        subjectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetMyBookingsResponse, any>({
        path: `/api/tutoring/bookings/mine`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetGuardianBookings
     * @request GET:/api/tutoring/bookings/guardian
     */
    tutoringControllerGetGuardianBookings: (
      query?: {
        /** @format uuid */
        subjectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGuardianBookingsResponse, any>({
        path: `/api/tutoring/bookings/guardian`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetGuardianStudents
     * @request GET:/api/tutoring/guardian/students
     */
    tutoringControllerGetGuardianStudents: (params: RequestParams = {}) =>
      this.request<GetGuardianStudentsResponse, any>({
        path: `/api/tutoring/guardian/students`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetGuardianBookableOptions
     * @request GET:/api/tutoring/guardian/bookable
     */
    tutoringControllerGetGuardianBookableOptions: (params: RequestParams = {}) =>
      this.request<GetGuardianBookableOptionsResponse, any>({
        path: `/api/tutoring/guardian/bookable`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetBookableSubjects
     * @request GET:/api/tutoring/bookable-subjects
     */
    tutoringControllerGetBookableSubjects: (params: RequestParams = {}) =>
      this.request<GetBookableSubjectsResponse, any>({
        path: `/api/tutoring/bookable-subjects`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetNextSlots
     * @request GET:/api/tutoring/next-slots
     */
    tutoringControllerGetNextSlots: (
      query?: {
        subjectIds?: string;
        includeUnowned?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetNextSlotsResponse, any>({
        path: `/api/tutoring/next-slots`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetBookingStatus
     * @request GET:/api/tutoring/bookings/{id}
     */
    tutoringControllerGetBookingStatus: (id: string, params: RequestParams = {}) =>
      this.request<GetBookingStatusResponse, any>({
        path: `/api/tutoring/bookings/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerCancelBooking
     * @request POST:/api/tutoring/bookings/{id}/cancel
     */
    tutoringControllerCancelBooking: (id: string, params: RequestParams = {}) =>
      this.request<CancelBookingResponse, any>({
        path: `/api/tutoring/bookings/${id}/cancel`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerRescheduleBooking
     * @request POST:/api/tutoring/bookings/{id}/reschedule
     */
    tutoringControllerRescheduleBooking: (
      id: string,
      data: RescheduleBookingBody,
      params: RequestParams = {},
    ) =>
      this.request<RescheduleBookingResponse, any>({
        path: `/api/tutoring/bookings/${id}/reschedule`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerRequestTutorCancellationRefund
     * @request POST:/api/tutoring/bookings/{id}/refund
     */
    tutoringControllerRequestTutorCancellationRefund: (id: string, params: RequestParams = {}) =>
      this.request<RequestTutorCancellationRefundResponse, any>({
        path: `/api/tutoring/bookings/${id}/refund`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerRebookAfterTutorCancellation
     * @request POST:/api/tutoring/bookings/{id}/rebook
     */
    tutoringControllerRebookAfterTutorCancellation: (
      id: string,
      data: RebookAfterTutorCancellationBody,
      params: RequestParams = {},
    ) =>
      this.request<RebookAfterTutorCancellationResponse, any>({
        path: `/api/tutoring/bookings/${id}/rebook`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerHandleWebhook
     * @request POST:/api/tutoring/webhook
     */
    tutoringControllerHandleWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/tutoring/webhook`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerGetBookingNote
     * @request GET:/api/tutoring/bookings/{id}/note
     */
    tutoringControllerGetBookingNote: (id: string, params: RequestParams = {}) =>
      this.request<GetBookingNoteResponse, any>({
        path: `/api/tutoring/bookings/${id}/note`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerHandleGraphTranscriptWebhook
     * @request POST:/api/tutoring/webhooks/graph-transcripts
     */
    tutoringControllerHandleGraphTranscriptWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/tutoring/webhooks/graph-transcripts`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringControllerHandleCalcomWebhook
     * @request POST:/api/tutoring/webhooks/calcom
     */
    tutoringControllerHandleCalcomWebhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/tutoring/webhooks/calcom`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerListTutors
     * @request GET:/api/admin/tutoring/tutors
     */
    tutoringAdminControllerListTutors: (params: RequestParams = {}) =>
      this.request<ListTutorsResponse, any>({
        path: `/api/admin/tutoring/tutors`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerCreateTutor
     * @request POST:/api/admin/tutoring/tutors
     */
    tutoringAdminControllerCreateTutor: (data: CreateTutorBody, params: RequestParams = {}) =>
      this.request<CreateTutorResponse, any>({
        path: `/api/admin/tutoring/tutors`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerGetTutor
     * @request GET:/api/admin/tutoring/tutors/{id}
     */
    tutoringAdminControllerGetTutor: (id: string, params: RequestParams = {}) =>
      this.request<GetTutorResponse, any>({
        path: `/api/admin/tutoring/tutors/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerUpdateTutor
     * @request PATCH:/api/admin/tutoring/tutors/{id}
     */
    tutoringAdminControllerUpdateTutor: (
      id: string,
      data: UpdateTutorBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTutorResponse, any>({
        path: `/api/admin/tutoring/tutors/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerListEventTypes
     * @request GET:/api/admin/tutoring/event-types
     */
    tutoringAdminControllerListEventTypes: (
      query?: {
        calcomUsername?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListEventTypesResponse, any>({
        path: `/api/admin/tutoring/event-types`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerAddTutorSubject
     * @request POST:/api/admin/tutoring/tutors/{id}/subjects
     */
    tutoringAdminControllerAddTutorSubject: (
      id: string,
      data: AddTutorSubjectBody,
      params: RequestParams = {},
    ) =>
      this.request<AddTutorSubjectResponse, any>({
        path: `/api/admin/tutoring/tutors/${id}/subjects`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerUpdateTutorSubject
     * @request PATCH:/api/admin/tutoring/tutor-subjects/{id}
     */
    tutoringAdminControllerUpdateTutorSubject: (
      id: string,
      data: UpdateTutorSubjectBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTutorSubjectResponse, any>({
        path: `/api/admin/tutoring/tutor-subjects/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerDeleteTutorSubject
     * @request DELETE:/api/admin/tutoring/tutor-subjects/{id}
     */
    tutoringAdminControllerDeleteTutorSubject: (id: string, params: RequestParams = {}) =>
      this.request<DeleteTutorSubjectResponse, any>({
        path: `/api/admin/tutoring/tutor-subjects/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerListLessonsMissingNote
     * @request GET:/api/admin/tutoring/notes/missing
     */
    tutoringAdminControllerListLessonsMissingNote: (params: RequestParams = {}) =>
      this.request<ListLessonsMissingNoteResponse, any>({
        path: `/api/admin/tutoring/notes/missing`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerListBookings
     * @request GET:/api/admin/tutoring/bookings
     */
    tutoringAdminControllerListBookings: (
      query?: {
        /** @format uuid */
        tutorId?: string;
        status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListBookingsResponse, any>({
        path: `/api/admin/tutoring/bookings`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerGetBooking
     * @request GET:/api/admin/tutoring/bookings/{id}
     */
    tutoringAdminControllerGetBooking: (id: string, params: RequestParams = {}) =>
      this.request<GetBookingResponse, any>({
        path: `/api/admin/tutoring/bookings/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerListRefunds
     * @request GET:/api/admin/tutoring/refunds
     */
    tutoringAdminControllerListRefunds: (params: RequestParams = {}) =>
      this.request<ListRefundsResponse, any>({
        path: `/api/admin/tutoring/refunds`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TutoringAdminControllerMarkRefunded
     * @request POST:/api/admin/tutoring/bookings/{id}/refunded
     */
    tutoringAdminControllerMarkRefunded: (id: string, params: RequestParams = {}) =>
      this.request<MarkRefundedResponse, any>({
        path: `/api/admin/tutoring/bookings/${id}/refunded`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerListReports
     * @request GET:/api/admin/reports
     */
    reportsControllerListReports: (params: RequestParams = {}) =>
      this.request<ListReportsResponse, any>({
        path: `/api/admin/reports`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerCreateReport
     * @request POST:/api/admin/reports
     */
    reportsControllerCreateReport: (
      data: {
        /** @format binary */
        file: File;
        /** @format binary */
        thumbnail?: File;
        name: string;
        config: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreateReportResponse, any>({
        path: `/api/admin/reports`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerListReportTemplates
     * @request GET:/api/admin/reports/templates
     */
    reportsControllerListReportTemplates: (params: RequestParams = {}) =>
      this.request<ListReportTemplatesResponse, any>({
        path: `/api/admin/reports/templates`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerCreateReportTemplate
     * @request POST:/api/admin/reports/templates
     */
    reportsControllerCreateReportTemplate: (
      data: CreateReportTemplateBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateReportTemplateResponse, any>({
        path: `/api/admin/reports/templates`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerDeleteReportTemplate
     * @request DELETE:/api/admin/reports/templates/{id}
     */
    reportsControllerDeleteReportTemplate: (id: string, params: RequestParams = {}) =>
      this.request<DeleteReportTemplateResponse, any>({
        path: `/api/admin/reports/templates/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerDownloadReport
     * @request GET:/api/admin/reports/{id}/file
     */
    reportsControllerDownloadReport: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api/admin/reports/${id}/file`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerDeleteReport
     * @request DELETE:/api/admin/reports/{id}
     */
    reportsControllerDeleteReport: (id: string, params: RequestParams = {}) =>
      this.request<DeleteReportResponse, any>({
        path: `/api/admin/reports/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetLearningReportRows
     * @request GET:/api/admin/reports/data/learning
     */
    reportsControllerGetLearningReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetLearningReportRowsResponse, any>({
        path: `/api/admin/reports/data/learning`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetQuizResultsReportRows
     * @request GET:/api/admin/reports/data/quiz-results
     */
    reportsControllerGetQuizResultsReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetQuizResultsReportRowsResponse, any>({
        path: `/api/admin/reports/data/quiz-results`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetSearchesReportRows
     * @request GET:/api/admin/reports/data/searches
     */
    reportsControllerGetSearchesReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSearchesReportRowsResponse, any>({
        path: `/api/admin/reports/data/searches`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetAchievementsReportRows
     * @request GET:/api/admin/reports/data/achievements
     */
    reportsControllerGetAchievementsReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAchievementsReportRowsResponse, any>({
        path: `/api/admin/reports/data/achievements`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetSubscriptionsReportRows
     * @request GET:/api/admin/reports/data/subscriptions
     */
    reportsControllerGetSubscriptionsReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSubscriptionsReportRowsResponse, any>({
        path: `/api/admin/reports/data/subscriptions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetSubscriptionRetentionReportRows
     * @request GET:/api/admin/reports/data/subscription-retention
     */
    reportsControllerGetSubscriptionRetentionReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSubscriptionRetentionReportRowsResponse, any>({
        path: `/api/admin/reports/data/subscription-retention`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetWeeklyRenewalsReportRows
     * @request GET:/api/admin/reports/data/weekly-renewals
     */
    reportsControllerGetWeeklyRenewalsReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetWeeklyRenewalsReportRowsResponse, any>({
        path: `/api/admin/reports/data/weekly-renewals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetWeeklyToMonthlyReportRows
     * @request GET:/api/admin/reports/data/weekly-to-monthly
     */
    reportsControllerGetWeeklyToMonthlyReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetWeeklyToMonthlyReportRowsResponse, any>({
        path: `/api/admin/reports/data/weekly-to-monthly`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetPaymentsReportRows
     * @request GET:/api/admin/reports/data/payments
     */
    reportsControllerGetPaymentsReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPaymentsReportRowsResponse, any>({
        path: `/api/admin/reports/data/payments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetOneTimeAccessesReportRows
     * @request GET:/api/admin/reports/data/one-time-accesses
     */
    reportsControllerGetOneTimeAccessesReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetOneTimeAccessesReportRowsResponse, any>({
        path: `/api/admin/reports/data/one-time-accesses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetTutoringReportRows
     * @request GET:/api/admin/reports/data/tutoring
     */
    reportsControllerGetTutoringReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetTutoringReportRowsResponse, any>({
        path: `/api/admin/reports/data/tutoring`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetDiscountCodesReportRows
     * @request GET:/api/admin/reports/data/discount-codes
     */
    reportsControllerGetDiscountCodesReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDiscountCodesReportRowsResponse, any>({
        path: `/api/admin/reports/data/discount-codes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetAccountsReportRows
     * @request GET:/api/admin/reports/data/accounts
     */
    reportsControllerGetAccountsReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
        roles?: ("STUDENT" | "GUARDIAN")[];
        period?: "registration" | "activity" | "any";
        access?: "all" | "paid" | "former";
        consent?: "any" | "consent" | "email" | "phone";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAccountsReportRowsResponse, any>({
        path: `/api/admin/reports/data/accounts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetAbandonedCartsReportRows
     * @request GET:/api/admin/reports/data/abandoned-carts
     */
    reportsControllerGetAbandonedCartsReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAbandonedCartsReportRowsResponse, any>({
        path: `/api/admin/reports/data/abandoned-carts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportsControllerGetPaymentErrorsReportRows
     * @request GET:/api/admin/reports/data/payment-errors
     */
    reportsControllerGetPaymentErrorsReportRows: (
      query: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to: string;
        schoolClassIds?: string[];
        subjectIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPaymentErrorsReportRowsResponse, any>({
        path: `/api/admin/reports/data/payment-errors`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminPaymentsControllerGetPayments
     * @request GET:/api/admin/payments
     */
    adminPaymentsControllerGetPayments: (
      query?: {
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
        sort?:
          | "paidAt"
          | "amount"
          | "paymentType"
          | "status"
          | "payerEmail"
          | "-paidAt"
          | "-amount"
          | "-paymentType"
          | "-status"
          | "-payerEmail";
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        paymentType?: "subscription" | "oneTimeBlik" | "tutoring";
        status?: "success" | "failed";
        purpose?:
          | "initial"
          | "renewal"
          | "upsell"
          | "interval-switch"
          | "interval-switch-merge"
          | "blik-reauthorization";
        paymentMethod?: "card" | "blik";
        /** @format uuid */
        schoolClassId?: string;
        /** @format uuid */
        subjectId?: string;
        keyword?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPaymentsResponse, any>({
        path: `/api/admin/payments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminPaymentsControllerGetPaymentsSummary
     * @request GET:/api/admin/payments/summary
     */
    adminPaymentsControllerGetPaymentsSummary: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        paymentType?: "subscription" | "oneTimeBlik" | "tutoring";
        status?: "success" | "failed";
        purpose?:
          | "initial"
          | "renewal"
          | "upsell"
          | "interval-switch"
          | "interval-switch-merge"
          | "blik-reauthorization";
        paymentMethod?: "card" | "blik";
        /** @format uuid */
        schoolClassId?: string;
        /** @format uuid */
        subjectId?: string;
        keyword?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPaymentsSummaryResponse, any>({
        path: `/api/admin/payments/summary`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminPaymentsControllerExportPayments
     * @request GET:/api/admin/payments/export
     */
    adminPaymentsControllerExportPayments: (
      query?: {
        sort?:
          | "paidAt"
          | "amount"
          | "paymentType"
          | "status"
          | "payerEmail"
          | "-paidAt"
          | "-amount"
          | "-paymentType"
          | "-status"
          | "-payerEmail";
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        paymentType?: "subscription" | "oneTimeBlik" | "tutoring";
        status?: "success" | "failed";
        purpose?:
          | "initial"
          | "renewal"
          | "upsell"
          | "interval-switch"
          | "interval-switch-merge"
          | "blik-reauthorization";
        paymentMethod?: "card" | "blik";
        /** @format uuid */
        schoolClassId?: string;
        /** @format uuid */
        subjectId?: string;
        keyword?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExportPaymentsResponse, any>({
        path: `/api/admin/payments/export`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminPaymentsControllerSetPaymentRefund
     * @request PATCH:/api/admin/payments/{paymentType}/{id}/refund
     */
    adminPaymentsControllerSetPaymentRefund: (
      paymentType: "subscription" | "oneTimeBlik" | "tutoring",
      id: string,
      data: SetPaymentRefundBody,
      params: RequestParams = {},
    ) =>
      this.request<SetPaymentRefundResponse, any>({
        path: `/api/admin/payments/${paymentType}/${id}/refund`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminDashboardControllerGetDashboard
     * @request GET:/api/admin/dashboard
     */
    adminDashboardControllerGetDashboard: (params: RequestParams = {}) =>
      this.request<GetDashboardResponse, any>({
        path: `/api/admin/dashboard`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentProgressControllerGetStudents
     * @request GET:/api/guardian/student-progress
     */
    studentProgressControllerGetStudents: (params: RequestParams = {}) =>
      this.request<GetStudentsResponse, any>({
        path: `/api/guardian/student-progress`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentProgressControllerGetProgress
     * @request GET:/api/guardian/student-progress/{studentId}
     */
    studentProgressControllerGetProgress: (
      studentId: string,
      query: {
        /** @format uuid */
        schoolClassId: string;
        /** @format uuid */
        subjectId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetProgressResponse, any>({
        path: `/api/guardian/student-progress/${studentId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentProgressSettingsControllerGetThresholds
     * @request GET:/api/admin/student-progress/thresholds
     */
    studentProgressSettingsControllerGetThresholds: (params: RequestParams = {}) =>
      this.request<GetThresholdsResponse, any>({
        path: `/api/admin/student-progress/thresholds`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentProgressSettingsControllerSaveThresholds
     * @request PATCH:/api/admin/student-progress/thresholds
     */
    studentProgressSettingsControllerSaveThresholds: (
      data: SaveThresholdsBody,
      params: RequestParams = {},
    ) =>
      this.request<SaveThresholdsResponse, any>({
        path: `/api/admin/student-progress/thresholds`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
